export default {
  'views.bizUser.query.email': '邮箱',
  'views.bizUser.query.emailPlaceholder': '请输入邮箱',
  'views.bizUser.query.nickname': '昵称',
  'views.bizUser.query.nicknamePlaceholder': '请输入昵称',
  'views.bizUser.query.isVip': '是否专业',
  'views.bizUser.query.isVipPlaceholder': '请选择是否专业',
  'views.bizUser.query.paymentMethod': '付款方式',
  'views.bizUser.query.paymentMethodPlaceholder': '请选择付款方式',
  'views.bizUser.query.userStatus': '用户状态',
  'views.bizUser.query.userStatusPlaceholder': '请选择用户状态',
  'views.bizUser.btn.query': '查询',
  'views.bizUser.btn.reset': '重置',
  'views.bizUser.btn.createAccount': '创建账号',
  'views.bizUser.option.notPro': '不专业',
  'views.bizUser.option.pro': '专业',
  'views.bizUser.option.paymentFull': '全款',
  'views.bizUser.option.paymentFirst': '首款',
  'views.bizUser.option.paymentMonthly': '月结',
  'views.bizUser.column.id': 'ID',
  'views.bizUser.column.email': '邮箱',
  'views.bizUser.column.nickname': '昵称',
  'views.bizUser.column.isVip': '是否专业',
  'views.bizUser.column.paymentMethod': '付款方式',
  'views.bizUser.column.firstRate': '首款比例',
  'views.bizUser.column.userStatus': '用户状态',
  'views.bizUser.column.createTime': '注册时间',
  'views.bizUser.column.operation': '操作',
  'views.bizUser.cell.dash': '-',
  'views.bizUser.action.resetPassword': '重置密码',
  'views.bizUser.action.editVipPayment': '修改专业/付款方式',
  'views.bizUser.pagination.total': '共 {total} 条',
  'views.bizUser.msg.operationSuccess': '操作成功',
  'views.bizUser.msg.statusFail': '状态更新失败',
  'views.bizUser.confirm.deleteTitle': '确认删除所选中数据?',
  'views.bizUser.confirm.deleteContent': '当前选中编号为{ids}的数据',
  'views.bizUser.msg.deleteSuccess': '删除成功',
  'views.bizUser.confirm.exportTitle': '是否确认导出?',
  'views.bizUser.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.bizUser.export.filename': '用户信息_{time}.xlsx',

  'views.bizUser.resetPwd.title': '重置密码',
  'views.bizUser.resetPwd.newPassword': '新密码',
  'views.bizUser.resetPwd.newPasswordPlaceholder': '请输入新密码',
  'views.bizUser.resetPwd.confirmPassword': '确认密码',
  'views.bizUser.resetPwd.confirmPasswordPlaceholder': '请确认密码',
  'views.bizUser.resetPwd.err.newPwdRequired': '请输入新密码',
  'views.bizUser.resetPwd.err.newPwdPattern': '请输入6-12位英文字母、数字的密码',
  'views.bizUser.resetPwd.err.confirmRequired': '请再次输入新密码确认',
  'views.bizUser.resetPwd.err.confirmMismatch': '两次输入的密码不一致',
  'views.bizUser.resetPwd.msg.success': '重置成功',

  'views.bizUser.vipPayment.title': '修改专业/付款方式',
  'views.bizUser.vipPayment.isVip': '是否专业',
  'views.bizUser.vipPayment.isVipPlaceholder': '请选择是否专业',
  'views.bizUser.vipPayment.paymentMethod': '付款方式',
  'views.bizUser.vipPayment.paymentMethodPlaceholder': '请选择付款方式',
  'views.bizUser.vipPayment.firstRate': '首款比例',
  'views.bizUser.vipPayment.firstRatePlaceholder': '请输入首款比例(0,1]',
  'views.bizUser.vipPayment.err.firstRateRequired': '请输入首款比例',
  'views.bizUser.vipPayment.err.firstRateNumber': '首款比例必须是数字',
  'views.bizUser.vipPayment.err.firstRateGt0': '首款比例必须大于0',
  'views.bizUser.vipPayment.err.firstRateLte1': '首款比例不能大于1',
  'views.bizUser.vipPayment.err.firstRateDecimal': '首款比例最多保留2位小数',
  'views.bizUser.vipPayment.rule.selectIsVip': '请选择是否专业',
  'views.bizUser.vipPayment.rule.selectPayment': '请选择付款方式',
  'views.bizUser.vipPayment.msg.success': '修改成功',

  'views.bizUser.createAccount.title': '创建账号',
  'views.bizUser.createAccount.email': '邮箱',
  'views.bizUser.createAccount.emailPlaceholder': '请输入登录邮箱',
  'views.bizUser.createAccount.nickname': '昵称',
  'views.bizUser.createAccount.nicknamePlaceholder': '请输入昵称',
  'views.bizUser.createAccount.mobile': '手机号',
  'views.bizUser.createAccount.mobilePlaceholder': '选填，用于手机号登录',
  'views.bizUser.createAccount.password': '登录密码',
  'views.bizUser.createAccount.passwordPlaceholder': '请输入6-12位字母+数字密码',
  'views.bizUser.createAccount.confirmPassword': '确认密码',
  'views.bizUser.createAccount.confirmPasswordPlaceholder': '请再次输入密码',
  'views.bizUser.createAccount.status': '用户状态',
  'views.bizUser.createAccount.save': '保存',
  'views.bizUser.createAccount.cancel': '取消',
  'views.bizUser.createAccount.rule.emailRequired': '请输入邮箱',
  'views.bizUser.createAccount.rule.emailFormat': '请输入正确的邮箱格式',
  'views.bizUser.createAccount.rule.nicknameRequired': '请输入昵称',
  'views.bizUser.createAccount.rule.statusRequired': '请选择用户状态',
  'views.bizUser.createAccount.msg.success': '创建成功',
  'views.bizUser.createAccount.msg.fail': '创建失败',

  'views.userCategory.query.name': '名称',
  'views.userCategory.query.namePlaceholder': '请输入名称',
  'views.userCategory.btn.query': '查询',
  'views.userCategory.btn.reset': '重置',
  'views.userCategory.btn.add': '新增',
  'views.userCategory.btn.edit': '修改',
  'views.userCategory.btn.delete': '删除',
  'views.userCategory.column.id': 'ID',
  'views.userCategory.column.name': '名称',
  'views.userCategory.column.nameEn': '名称(英文)',
  'views.userCategory.column.sort': '排序',
  'views.userCategory.column.status': '状态',
  'views.userCategory.column.createTime': '创建时间',
  'views.userCategory.column.operation': '操作',
  'views.userCategory.pagination.total': '共 {total} 条',
  'views.userCategory.confirm.deleteTitle': '确认删除所选中数据?',
  'views.userCategory.confirm.deleteContent': '当前选中编号为{ids}的数据',
  'views.userCategory.msg.deleteSuccess': '删除成功',
  'views.userCategory.confirm.exportTitle': '是否确认导出?',
  'views.userCategory.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.userCategory.export.filename': '产品分类_{time}.xlsx',
  'views.userCategory.msg.statusOk': '状态更新成功',
  'views.userCategory.msg.statusFail': '状态更新失败',
  'views.userCategory.msg.sortOk': '排序更新成功',
  'views.userCategory.msg.sortFail': '排序更新失败',

  'views.userCategory.form.name': '名称',
  'views.userCategory.form.namePlaceholder': '请输入名称',
  'views.userCategory.form.nameEn': '名称(英文)',
  'views.userCategory.form.nameEnPlaceholder': '请输入名称(英文)',
  'views.userCategory.form.save': '保存',
  'views.userCategory.form.cancel': '取消',
  'views.userCategory.rule.nameRequired': '名称不能为空',
  'views.userCategory.title.add': '添加',
  'views.userCategory.title.edit': '修改',
  'views.userCategory.msg.updateOk': '修改成功',
  'views.userCategory.msg.updateFail': '修改失败',
  'views.userCategory.msg.addOk': '新增成功',
  'views.userCategory.msg.addFail': '新增失败',

  'views.appConfig.query.configGroup': '分组',
  'views.appConfig.query.configGroupPlaceholder': '请输入分组',
  'views.appConfig.query.configName': '变量名',
  'views.appConfig.query.configNamePlaceholder': '请输入变量名',
  'views.appConfig.query.title': '变量标题',
  'views.appConfig.query.titlePlaceholder': '请输入变量标题',
  'views.appConfig.btn.query': '查询',
  'views.appConfig.btn.reset': '重置',
  'views.appConfig.btn.add': '新增',
  'views.appConfig.btn.edit': '修改',
  'views.appConfig.btn.delete': '删除',
  'views.appConfig.column.id': 'ID',
  'views.appConfig.column.configGroup': '分组',
  'views.appConfig.column.configName': '变量名',
  'views.appConfig.column.varTitle': '变量标题',
  'views.appConfig.column.description': '描述',
  'views.appConfig.column.configValue': '值',
  'views.appConfig.column.configValueEn': '值（英文）',
  'views.appConfig.column.operation': '操作',
  'views.appConfig.pagination.total': '共 {total} 条',
  'views.appConfig.confirm.deleteTitle': '确认删除所选中数据?',
  'views.appConfig.confirm.deleteContent': '当前选中编号为{ids}的数据',
  'views.appConfig.msg.deleteSuccess': '删除成功',
  'views.appConfig.confirm.exportTitle': '是否确认导出?',
  'views.appConfig.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.appConfig.export.filename': '系统配置_{time}.xlsx',

  'views.appConfig.form.group': '分组',
  'views.appConfig.form.groupPlaceholder': '请输入分组',
  'views.appConfig.form.varName': '变量名',
  'views.appConfig.form.varNamePlaceholder': '请输入变量名',
  'views.appConfig.form.varTitle': '变量标题',
  'views.appConfig.form.varTitlePlaceholder': '请输入变量标题',
  'views.appConfig.form.paramType': '参数类型',
  'views.appConfig.form.value': '值',
  'views.appConfig.form.valuePlaceholder': '请输入',
  'views.appConfig.form.valueNumberPlaceholder': '请输入值',
  'views.appConfig.form.valueEn': '值（英文）',
  'views.appConfig.form.valueEnPlaceholder': '请输入英文值',
  'views.appConfig.form.description': '描述',
  'views.appConfig.form.descriptionPlaceholder': '请输入描述',
  'views.appConfig.form.save': '保存',
  'views.appConfig.form.cancel': '取消',
  'views.appConfig.type.text': '文本框',
  'views.appConfig.type.richText': '富文本',
  'views.appConfig.type.number': '数字',
  'views.appConfig.type.image': '图片',
  'views.appConfig.rule.groupRequired': '分组不能为空',
  'views.appConfig.rule.nameRequired': '变量名不能为空',
  'views.appConfig.rule.titleRequired': '变量标题不能为空',
  'views.appConfig.rule.valueRequired': '值不能为空',
  'views.appConfig.rule.typeRequired': '类型不能为空',
  'views.appConfig.msg.imageOnly': '请上传图片',
  'views.appConfig.upload.uploading': '上传中',
  'views.appConfig.upload.action': '上传',
  'views.appConfig.title.add': '添加',
  'views.appConfig.title.edit': '修改',
  'views.appConfig.msg.addOk': '新增成功',
  'views.appConfig.msg.updateOk': '修改成功',

  'views.appFeedback.query.nickname': '用户昵称',
  'views.appFeedback.query.nicknamePlaceholder': '请输入用户昵称',
  'views.appFeedback.query.contact': '联系方式',
  'views.appFeedback.query.contactPlaceholder': '请输入联系方式',
  'views.appFeedback.query.processStatus': '回复状态',
  'views.appFeedback.query.processStatusPlaceholder': '请选择回复状态',
  'views.appFeedback.processStatus.pending': '待回复',
  'views.appFeedback.processStatus.done': '已回复',
  'views.appFeedback.processStatus.skipped': '暂不回复',
  'views.appFeedback.btn.query': '查询',
  'views.appFeedback.btn.reset': '重置',
  'views.appFeedback.btn.delete': '删除',
  'views.appFeedback.btn.handle': '回复',
  'views.appFeedback.title.replyAudit': '回复',
  'views.appFeedback.title.add': '添加',
  'views.appFeedback.img.notUploaded': '未上传',
  'views.appFeedback.img.previewFallback': '用户未上传',
  'views.appFeedback.column.seq': '#',
  'views.appFeedback.column.id': 'ID',
  'views.appFeedback.column.nickname': '用户昵称',
  'views.appFeedback.column.feedbackType': '反馈类型',
  'views.appFeedback.column.content': '问题描述',
  'views.appFeedback.column.imgUrls': '反馈图片',
  'views.appFeedback.column.contact': '联系方式',
  'views.appFeedback.column.processStatus': '回复状态',
  'views.appFeedback.column.processResult': '回复内容',
  'views.appFeedback.form.processResultPlaceholder': '请输入回复内容',
  'views.appFeedback.column.processResultEn': '回复内容(英文)',
  'views.appFeedback.form.processResultEnPlaceholder': '请输入回复内容(英文)',
  'views.appFeedback.form.save': '保存',
  'views.appFeedback.form.cancel': '取消',
  'views.appFeedback.column.createTime': '创建时间',
  'views.appFeedback.column.operation': '操作',
  'views.appFeedback.pagination.total': '共 {total} 条',
  'views.appFeedback.confirm.deleteTitle': '确认删除所选中数据?',
  'views.appFeedback.confirm.deleteContent': '当前选中编号为 {ids} 的数据',
  'views.appFeedback.msg.deleteSuccess': '删除成功',
  'views.appFeedback.msg.updateSuccess': '修改成功',
  'views.appFeedback.msg.addSuccess': '新增成功',

  'views.homeNotice.query.title': '标题',
  'views.homeNotice.query.titlePlaceholder': '请输入标题',
  'views.homeNotice.query.sort': '排序',
  'views.homeNotice.query.sortPlaceholder': '请输入排序',
  'views.homeNotice.btn.query': '查询',
  'views.homeNotice.btn.reset': '重置',
  'views.homeNotice.btn.add': '新增',
  'views.homeNotice.btn.edit': '修改',
  'views.homeNotice.btn.delete': '删除',
  'views.homeNotice.column.id': 'ID',
  'views.homeNotice.column.title': '标题',
  'views.homeNotice.column.content': '内容',
  'views.homeNotice.column.contentEn': '内容（英文）',
  'views.homeNotice.column.sort': '排序',
  'views.homeNotice.column.status': '状态',
  'views.homeNotice.column.createTime': '创建时间',
  'views.homeNotice.column.operation': '操作',
  'views.homeNotice.pagination.total': '共 {total} 条',
  'views.homeNotice.confirm.deleteTitle': '确认删除所选中数据?',
  'views.homeNotice.confirm.deleteContent': '当前选中编号为 {ids} 的数据',
  'views.homeNotice.msg.deleteSuccess': '删除成功',
  'views.homeNotice.confirm.exportTitle': '是否确认导出?',
  'views.homeNotice.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.homeNotice.export.filename': '首页通知_{time}.xlsx',
  'views.homeNotice.msg.statusUpdateSuccess': '状态更新成功',
  'views.homeNotice.msg.statusUpdateFail': '状态更新失败',
  'views.homeNotice.msg.sortUpdateSuccess': '排序更新成功',
  'views.homeNotice.msg.sortUpdateFail': '排序更新失败',

  'views.homeNotice.form.title': '标题',
  'views.homeNotice.form.titlePlaceholder': '请输入标题',
  'views.homeNotice.form.content': '内容',
  'views.homeNotice.form.contentEn': '内容（英文）',
  'views.homeNotice.form.save': '保存',
  'views.homeNotice.form.cancel': '取消',
  'views.homeNotice.title.add': '添加',
  'views.homeNotice.title.edit': '修改',
  'views.homeNotice.rule.titleRequired': '标题不能为空',
  'views.homeNotice.rule.contentRequired': '内容不能为空',
  'views.homeNotice.msg.addOk': '新增成功',
  'views.homeNotice.msg.updateOk': '修改成功',
  'views.homeNotice.msg.addFail': '新增失败',
  'views.homeNotice.msg.updateFail': '修改失败',

  'views.banner.query.type': '位置',
  'views.banner.query.typePlaceholder': '请选择位置',
  'views.banner.query.title': '标题',
  'views.banner.query.titlePlaceholder': '请输入标题',
  'views.banner.query.link': '跳转ID',
  'views.banner.query.linkPlaceholder': '请输入跳转ID',
  'views.banner.query.linkUrl': '外部链接地址',
  'views.banner.query.linkUrlPlaceholder': '请输入外部链接地址',
  'views.banner.query.sort': '排序',
  'views.banner.query.sortPlaceholder': '请输入排序',
  'views.banner.btn.query': '查询',
  'views.banner.btn.reset': '重置',
  'views.banner.btn.add': '新增',
  'views.banner.btn.edit': '修改',
  'views.banner.btn.delete': '删除',
  'views.banner.type.home': '首页',
  'views.banner.type.company': '公司简介',
  'views.banner.column.id': 'ID',
  'views.banner.column.type': '位置',
  'views.banner.column.title': '标题',
  'views.banner.column.titleEn': '标题（英文）',
  'views.banner.column.content': '内容',
  'views.banner.column.contentEn': '内容（英文）',
  'views.banner.column.imgUrl': '图片',
  'views.banner.column.status': '状态',
  'views.banner.column.sort': '排序',
  'views.banner.column.createTime': '创建时间',
  'views.banner.column.operation': '操作',
  'views.banner.pagination.total': '共 {total} 条',
  'views.banner.confirm.deleteTitle': '确认删除所选中数据?',
  'views.banner.confirm.deleteContent': '当前选中编号为 {ids} 的数据',
  'views.banner.msg.deleteSuccess': '删除成功',
  'views.banner.confirm.exportTitle': '是否确认导出?',
  'views.banner.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.banner.export.filename': '轮播图_{time}.xlsx',
  'views.banner.msg.inlineSaveOk': '操作成功！',

  'views.banner.form.type': '位置',
  'views.banner.form.typePlaceholder': '请选择位置',
  'views.banner.form.title': '标题',
  'views.banner.form.titlePlaceholder': '请输入标题',
  'views.banner.form.titleEn': '标题（英文）',
  'views.banner.form.titleEnPlaceholder': '请输入英文标题',
  'views.banner.form.remark': '简介',
  'views.banner.form.remarkPlaceholder': '请输入简介',
  'views.banner.form.remarkEn': '简介（英文）',
  'views.banner.form.remarkEnPlaceholder': '请输入英文简介',
  'views.banner.form.content': '内容',
  'views.banner.form.contentEn': '内容（英文）',
  'views.banner.form.linkType': '跳转类型',
  'views.banner.form.linkTypePlaceholder': '请选择跳转类型',
  'views.banner.form.linkTypeNone': '不跳转',
  'views.banner.form.linkTypeOuter': '外链',
  'views.banner.form.linkUrl': '外部链接地址',
  'views.banner.form.linkUrlPlaceholder': '请输入外部链接地址',
  'views.banner.form.image': '图片',
  'views.banner.form.save': '保存',
  'views.banner.form.cancel': '取消',
  'views.banner.title.add': '添加',
  'views.banner.title.edit': '修改',
  'views.banner.rule.imgRequired': '轮播图不能为空',
  'views.banner.rule.sortRequired': '排序不能为空',
  'views.banner.msg.addOk': '新增成功',
  'views.banner.msg.updateOk': '修改成功',
  'views.banner.msg.companyTypeExists': '已存在公司简介类型的轮播，不可重复添加',

  'views.systemNotice.query.type': '公告类型',
  'views.systemNotice.query.typePlaceholder': '请选择公告类型',
  'views.systemNotice.query.title': '公告标题',
  'views.systemNotice.query.titlePlaceholder': '请输入',
  'views.systemNotice.btn.query': '查询',
  'views.systemNotice.btn.reset': '重置',
  'views.systemNotice.btn.add': '新增',
  'views.systemNotice.btn.edit': '修改',
  'views.systemNotice.btn.delete': '删除',
  'views.systemNotice.column.id': 'ID',
  'views.systemNotice.column.type': '公告类型',
  'views.systemNotice.type.notice': '通知',
  'views.systemNotice.type.versionUpdate': '版本更新',
  'views.systemNotice.column.title': '公告标题',
  'views.systemNotice.column.titleEn': '公告标题（英文）',
  'views.systemNotice.column.image': '图片',
  'views.systemNotice.column.content': '内容',
  'views.systemNotice.column.contentEn': '内容（英文）',
  'views.systemNotice.column.status': '状态',
  'views.systemNotice.column.createTime': '创建时间',
  'views.systemNotice.column.operation': '操作',
  'views.systemNotice.pagination.total': '共 {total} 条',
  'views.systemNotice.confirm.deleteTitle': '确认删除所选中数据?',
  'views.systemNotice.confirm.deleteContent': '当前选中编号为 {ids} 的数据',
  'views.systemNotice.msg.deleteSuccess': '删除成功',

  'views.systemNotice.form.noticeType': '公告类型',
  'views.systemNotice.form.noticeTypePlaceholder': '请选择公告类型',
  'views.systemNotice.form.title': '标题',
  'views.systemNotice.form.titlePlaceholder': '请输入标题',
  'views.systemNotice.form.titleEn': '标题（英文）',
  'views.systemNotice.form.titleEnPlaceholder': '请输入英文标题',
  'views.systemNotice.form.image': '图片',
  'views.systemNotice.form.content': '内容',
  'views.systemNotice.form.contentEn': '内容（英文）',
  'views.systemNotice.form.save': '保存',
  'views.systemNotice.form.cancel': '取消',
  'views.systemNotice.title.add': '添加公告',
  'views.systemNotice.title.edit': '修改公告',
  'views.systemNotice.rule.typeRequired': '公告类型不能为空',
  'views.systemNotice.rule.titleRequired': '公告标题不能为空',
  'views.systemNotice.rule.contentRequired': '请输入内容',
  'views.systemNotice.msg.addOk': '新增成功',
  'views.systemNotice.msg.updateOk': '修改成功',

  'component.tableSetting.sizeDefault': '默认',
  'component.tableSetting.sizeMiddle': '中等',
  'component.tableSetting.sizeSmall': '紧凑',
  'component.tableSetting.columnShowSort': '列展示/排序',
  'component.tableSetting.columnDragHint': '列排序需拖动名称',

  'views.goodsOrder.action.paymentRecord': '支付记录',
  'views.goodsOrder.action.detail': '详情',
  'views.goodsOrder.drawer.paymentTitleWithOrder': '支付记录（订单：{orderNo}）',
  'views.goodsOrder.drawer.detailTitleWithOrder': '订单详情（{orderNo}）',
  'views.goodsOrder.detail.userId': '用户ID',
  'views.goodsOrder.detail.goodsId': '商品ID',
  'views.goodsOrder.detail.firstStatus': '首款状态',
  'views.goodsOrder.detail.finalStatus': '尾款状态',
  'views.goodsOrder.detail.productionStatus': '生产状态',
  'views.goodsOrder.detail.typesettingType': '排版方式',
  'views.goodsOrder.detail.rowStatus': '启用状态',
  'views.goodsOrder.detail.remark': '备注',
  'views.goodsOrder.detail.priceTierTitle': '价格阶梯表',
  'views.goodsOrder.detail.priceTierTotalQty': '合计数量',
  'views.goodsOrder.detail.priceTierPrice': '价格',
  'views.goodsOrder.detail.priceTierMoneyFmt': '¥{amount}',
  'views.goodsOrder.detail.empty': '暂无数据',
  'views.goodsOrder.detail.productionProgress': '生产进度',
  'views.goodsOrder.detail.deliveryInfo': '发货信息',
  'views.goodsOrder.detail.copy': '复制',
  'views.goodsOrder.detail.copyOk': '已复制到剪贴板',
  'views.goodsOrder.detail.copyFail': '复制失败',
  'views.goodsOrder.detail.copyEmpty': '无内容可复制',
  'views.goodsOrder.detail.shippingAddress': '收货地址',
  'views.goodsOrder.detail.receiverName': '收件人',
  'views.goodsOrder.detail.receiverPhone': '手机号码',
  'views.goodsOrder.detail.addressLabel': '地址标签',
  'views.goodsOrder.detail.detailedAddress': '地址信息',
  'views.goodsOrder.detail.productDetail': '产品明细',
  'views.goodsOrder.detail.quoteDetail': '报价明细',
  'views.goodsOrder.detail.styleCount': '款数',
  'views.goodsOrder.detail.exchangeRateLabel': '汇率',
  'views.goodsOrder.detail.weightLabel': '重量',
  'views.goodsOrder.detail.shippingMethodLabel': '运输方式',
  'views.goodsOrder.detail.shippingFee': '运费',
  'views.goodsOrder.detail.priceInfo': '价格信息',
  'views.goodsOrder.detail.paymentMethod': '付款方式',
  'views.goodsOrder.detail.orderAmount': '订单金额',
  'views.goodsOrder.detail.payModeFull': '全款',
  'views.goodsOrder.detail.payModeFirstFinal': '首款-尾款',
  'views.goodsOrder.detail.payModeMonthly': '月结',
  'views.goodsOrder.subPayment.pending': '待支付',
  'views.goodsOrder.subPayment.confirmed': '已确认',
  'views.goodsOrder.subPayment.rejected': '已驳回',
  'views.goodsOrder.typesetting.normal': '正常',
  'views.goodsOrder.typesetting.doubleFeed': '双放料',
  'views.goodsOrder.bool.yes': '是',
  'views.goodsOrder.bool.no': '否',
  'views.goodsOrder.msg.loadDetailFail': '加载订单详情失败',
  'views.goodsOrder.action.query': '查询',
  'views.goodsOrder.action.reset': '重置',
  'views.goodsOrder.action.delete': '删除',
  'views.goodsOrder.action.markDraftReceived': '已收稿',
  'views.goodsOrder.confirm.markDraftReceivedTitle': '确认标记为已收稿？',
  'views.goodsOrder.confirm.markDraftReceivedContent': '订单号：{orderNo}，将把状态从「待发稿」更新为「已收稿」。',
  'views.goodsOrder.msg.markDraftReceivedOk': '已标记为已收稿',
  'views.goodsOrder.action.editSubmissionEmail': '收稿邮箱',
  'views.goodsOrder.modal.editSubmissionEmailTitle': '修改收稿邮箱',
  'views.goodsOrder.modal.submissionEmailLabel': '收稿邮箱号',
  'views.goodsOrder.modal.submissionEmailPlaceholder': '请输入收稿邮箱，留空则清空',
  'views.goodsOrder.msg.submissionEmailOk': '收稿邮箱已更新',
  'views.goodsOrder.msg.submissionEmailInvalid': '请输入正确的邮箱格式',
  'views.goodsOrder.action.markProducing': '设为生产中',
  'views.goodsOrder.confirm.markProducingTitle': '确认设为生产中？',
  'views.goodsOrder.confirm.markProducingContent': '订单号：{orderNo}，将把订单状态从「已收稿」更新为「生产中」，并将生产环节设为「排版」。',
  'views.goodsOrder.msg.markProducingOk': '已设为生产中',
  'views.goodsOrder.action.editProductionStatus': '修改生产状态',
  'views.goodsOrder.modal.editProductionStatusTitle': '修改生产状态',
  'views.goodsOrder.modal.productionStatusPlaceholder': '请选择生产环节',
  'views.goodsOrder.msg.updateProductionStatusOk': '生产状态已更新',
  'views.goodsOrder.action.submitOrderBoxes': '箱规待发',
  'views.goodsOrder.modal.submitOrderBoxesTitle': '录入箱规并转待发货',
  'views.goodsOrder.msg.submitOrderBoxesOk': '箱规已保存，订单已转为待发货',
  'views.goodsOrder.action.markShippedFromAwaitShip': '标记已发货',
  'views.goodsOrder.action.markAwaitFinalPaymentFromAwaitShip': '标记待收尾款',
  'views.goodsOrder.confirm.markShippedFromAwaitShipTitle': '确认标记为已发货？',
  'views.goodsOrder.confirm.markShippedFromAwaitShipContent': '订单号：{orderNo}，将把状态从「待发货」更新为「已发货」。',
  'views.goodsOrder.msg.markShippedFromAwaitShipOk': '已标记为已发货',
  'views.goodsOrder.modal.markShippedTitle': '标记已发货',
  'views.goodsOrder.modal.markShippedDeliveryNumberPlaceholder': '请输入',
  'views.goodsOrder.msg.markShippedDeliveryNumberRequired': '请输入发货单号',
  'views.goodsOrder.msg.markShippedDeliveryTimeRequired': '请选择发货时间',
  'views.goodsOrder.confirm.markAwaitFinalPaymentFromAwaitShipTitle': '确认标记为待收尾款？',
  'views.goodsOrder.confirm.markAwaitFinalPaymentFromAwaitShipContent': '订单号：{orderNo}，将把状态从「待发货」更新为「待收尾款」。',
  'views.goodsOrder.msg.markAwaitFinalPaymentFromAwaitShipOk': '已标记为待收尾款',
  'views.goodsOrder.action.markCompletedFromShipped': '标记已完成',
  'views.goodsOrder.confirm.markCompletedFromShippedTitle': '确认标记为已完成？',
  'views.goodsOrder.confirm.markCompletedFromShippedContent': '订单号：{orderNo}，将把状态从「已发货」更新为「已完成」。',
  'views.goodsOrder.msg.markCompletedFromShippedOk': '已标记为已完成',
  'views.goodsOrder.orderBox.boxLength': '箱长',
  'views.goodsOrder.orderBox.boxWidth': '箱宽',
  'views.goodsOrder.orderBox.boxHeight': '箱高',
  'views.goodsOrder.orderBox.boxNum': '箱数',
  'views.goodsOrder.orderBox.remark': '备注',
  'views.goodsOrder.orderBox.addRow': '添加一行',
  'views.goodsOrder.orderBox.removeRow': '删除',
  'views.goodsOrder.orderBox.validateRows': '请填写每行的箱长、箱宽、箱高，且箱数须为大于等于 1 的整数',
  'views.goodsOrder.orderBox.keepOneRow': '至少保留一行',
  'views.goodsOrder.orderBox.noShippingAddress': '暂无收货地址信息',
  'views.goodsOrder.orderBox.deliveryNumber': '发货单号',
  'views.goodsOrder.orderBox.deliveryNumberPlaceholder': '请输入',
  'views.goodsOrder.orderBox.deliveryTime': '发货时间',
  'views.goodsOrder.orderBox.deliveryTimePlaceholder': '请选择发货时间',
  'views.goodsOrder.orderBox.deliveryTimeRequired': '每一行均需选择发货时间',
  'views.goodsOrder.productionStage.1': '排版',
  'views.goodsOrder.productionStage.2': '印刷',
  'views.goodsOrder.productionStage.3': '复合',
  'views.goodsOrder.productionStage.4': '熟化',
  'views.goodsOrder.productionStage.5': '分切',
  'views.goodsOrder.productionStage.6': '制袋',
  'views.goodsOrder.productionStage.7': '检验',
  'views.goodsOrder.productionStage.8': '入库',
  'views.goodsOrder.search.goodsName': '产品名称',
  'views.goodsOrder.search.goodsNamePlaceholder': '请输入产品名称',
  'views.goodsOrder.search.orderType': '订单类型',
  'views.goodsOrder.search.orderTypePlaceholder': '请选择订单类型',
  'views.goodsOrder.search.orderStatus': '订单状态',
  'views.goodsOrder.search.orderStatusPlaceholder': '请选择订单状态',
  'views.goodsOrder.search.orderNo': '订单号',
  'views.goodsOrder.search.orderNoPlaceholder': '请输入订单号',
  'views.goodsOrder.search.email': '用户邮箱',
  'views.goodsOrder.search.emailPlaceholder': '请输入用户邮箱',
  'views.goodsOrder.search.nickname': '用户昵称',
  'views.goodsOrder.search.nicknamePlaceholder': '请输入用户昵称',
  'views.goodsOrder.search.createTime': '创建时间',
  'views.goodsOrder.search.createTimeStart': '开始时间',
  'views.goodsOrder.search.createTimeEnd': '结束时间',
  'views.goodsOrder.search.width': '宽',
  'views.goodsOrder.search.widthPlaceholder': '请输入宽',
  'views.goodsOrder.search.height': '高',
  'views.goodsOrder.search.heightPlaceholder': '请输入高',
  'views.goodsOrder.search.bottom': '底',
  'views.goodsOrder.search.bottomPlaceholder': '请输入底',
  'views.goodsOrder.search.weight': '重量',
  'views.goodsOrder.search.weightPlaceholder': '请输入重量',
  'views.goodsOrder.search.exchangeRate': '汇率值',
  'views.goodsOrder.search.exchangeRatePlaceholder': '请输入汇率值',
  'views.goodsOrder.search.shippingMethod': '运费方式',
  'views.goodsOrder.search.shippingMethodPlaceholder': '请输入运费方式',
  'views.goodsOrder.search.stylesNum': '款式数量',
  'views.goodsOrder.search.stylesNumPlaceholder': '请输入款式数量',
  'views.goodsOrder.search.totalNum': '合计数量',
  'views.goodsOrder.search.totalNumPlaceholder': '请输入合计数量',
  'views.goodsOrder.search.payMoney': '应付金额',
  'views.goodsOrder.search.payMoneyPlaceholder': '请输入应付金额',
  'views.goodsOrder.search.firstMoney': '首款金额',
  'views.goodsOrder.search.firstMoneyPlaceholder': '请输入首款金额',
  'views.goodsOrder.search.finalMoney': '尾款金额',
  'views.goodsOrder.search.finalMoneyPlaceholder': '请输入尾款金额',
  'views.goodsOrder.search.paidMoney': '已付金额',
  'views.goodsOrder.search.paidMoneyPlaceholder': '请输入已付金额',
  'views.goodsOrder.search.shippingMoney': '运费金额',
  'views.goodsOrder.search.shippingMoneyPlaceholder': '请输入运费金额',
  'views.goodsOrder.search.calculationFormula': '计算公式',
  'views.goodsOrder.search.calculationFormulaPlaceholder': '请输入计算公式',
  'views.goodsOrder.search.goodMoney': '实际金额',
  'views.goodsOrder.search.goodMoneyPlaceholder': '请输入实际金额',
  'views.goodsOrder.search.printingMeters': '印刷米数',
  'views.goodsOrder.search.printingMetersPlaceholder': '请输入印刷米数',
  'views.goodsOrder.search.sort': '排序',
  'views.goodsOrder.search.sortPlaceholder': '请输入排序',
  'views.goodsOrder.column.id': 'ID',
  'views.goodsOrder.column.email': '用户邮箱',
  'views.goodsOrder.column.nickname': '用户昵称',
  'views.goodsOrder.column.orderType': '订单类型',
  'views.goodsOrder.column.goodsName': '产品名称',
  'views.goodsOrder.column.orderStatus': '订单状态',
  'views.goodsOrder.column.productionStatus': '生产状态',
  'views.goodsOrder.column.orderNo': '订单号',
  'views.goodsOrder.column.height': '高',
  'views.goodsOrder.column.width': '宽',
  'views.goodsOrder.column.bottom': '底',
  'views.goodsOrder.column.thickness': '厚度',
  'views.goodsOrder.column.stylesNum': '款式数量',
  'views.goodsOrder.column.totalNum': '合计数量',
  'views.goodsOrder.column.payMoney': '商品报价',
  'views.goodsOrder.column.createTime': '创建时间',
  'views.goodsOrder.column.operation': '操作',
  'views.goodsOrder.orderType.full': '全款订单',
  'views.goodsOrder.orderType.first': '首款订单',
  'views.goodsOrder.orderType.monthly': '月结订单',
  'views.goodsOrder.orderStatus.pending': '待下单',
  'views.goodsOrder.orderStatus.awaitPay': '已下单待付款',
  'views.goodsOrder.orderStatus.paidAwaitAudit': '已付款待审核',
  'views.goodsOrder.orderStatus.factoryRejected': '工厂驳回付款申请',
  'views.goodsOrder.orderStatus.awaitDraft': '待发稿',
  'views.goodsOrder.orderStatus.draftReceived': '已收稿',
  'views.goodsOrder.orderStatus.producing': '生产中',
  'views.goodsOrder.orderStatus.awaitShip': '待发货',
  'views.goodsOrder.orderStatus.awaitFinalPayment': '待收尾款',
  'views.goodsOrder.orderStatus.shipped': '已发货',
  'views.goodsOrder.orderStatus.completed': '已完成',
  'views.goodsOrder.orderStatus.cancelled': '已取消',
  'views.goodsOrder.pagination.total': '共 {total} 条',
  'views.goodsOrder.confirm.deleteTitle': '确认删除所选中数据?',
  'views.goodsOrder.confirm.deleteContent': '当前选中编号为 {ids} 的数据',
  'views.goodsOrder.msg.deleteOk': '删除成功',
  'views.goodsOrder.confirm.exportTitle': '是否确认导出?',
  'views.goodsOrder.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.goodsOrder.export.filename': '订单_{time}.xlsx',
  'views.goodsOrder.msg.statusOk': '状态更新成功',
  'views.goodsOrder.msg.statusFail': '状态更新失败',
  'views.goodsOrder.msg.sortOk': '排序更新成功',
  'views.goodsOrder.msg.sortFail': '排序更新失败',

  'views.orderPayment.drawer.title': '订单付款',
  'views.orderPayment.search.orderId': '订单ID',
  'views.orderPayment.search.orderIdPlaceholder': '请输入订单ID',
  'views.orderPayment.search.money': '金额',
  'views.orderPayment.search.moneyPlaceholder': '请输入金额',
  'views.orderPayment.search.sort': '排序',
  'views.orderPayment.search.sortPlaceholder': '请输入排序',
  'views.orderPayment.search.expand': '展开',
  'views.orderPayment.search.collapse': '收起',
  'views.orderPayment.action.query': '查询',
  'views.orderPayment.action.reset': '重置',
  'views.orderPayment.action.add': '新增',
  'views.orderPayment.action.edit': '修改',
  'views.orderPayment.action.audit': '审核',
  'views.orderPayment.action.delete': '删除',
  'views.orderPayment.column.id': 'ID',
  'views.orderPayment.column.orderId': '订单ID',
  'views.orderPayment.column.type': '类型',
  'views.orderPayment.column.money': '金额',
  'views.orderPayment.column.url': '付款截图',
  'views.orderPayment.column.auditStatus': '审核状态',
  'views.orderPayment.paymentType.full': '全款截图',
  'views.orderPayment.paymentType.first': '首款截图',
  'views.orderPayment.paymentType.final': '尾款截图',
  'views.orderPayment.paymentType.unknown': '未知（{value}）',
  'views.orderPayment.auditStatus.pending': '待审核',
  'views.orderPayment.auditStatus.approved': '审核通过',
  'views.orderPayment.auditStatus.rejected': '审核驳回',
  'views.orderPayment.auditStatus.unknown': '未知（{value}）',
  'views.orderPayment.column.auditReason': '审核原因',
  'views.orderPayment.column.auditReasonEn': '审核原因(英文)',
  'views.orderPayment.column.sort': '排序',
  'views.orderPayment.column.status': '状态',
  'views.orderPayment.column.createTime': '创建时间',
  'views.orderPayment.column.operation': '操作',
  'views.orderPayment.pagination.total': '共 {total} 条',
  'views.orderPayment.confirm.deleteTitle': '确认删除所选中数据？',
  'views.orderPayment.confirm.deleteContent': '当前选中编号为 {ids} 的数据',
  'views.orderPayment.msg.deleteOk': '删除成功',
  'views.orderPayment.msg.statusOk': '状态更新成功',
  'views.orderPayment.msg.statusFail': '状态更新失败',
  'views.orderPayment.msg.sortOk': '排序更新成功',
  'views.orderPayment.msg.sortFail': '排序更新失败',
  'views.orderPayment.form.titleAdd': '添加',
  'views.orderPayment.form.titleEdit': '修改',
  'views.orderPayment.form.orderId': '订单ID',
  'views.orderPayment.form.orderIdPlaceholder': '请输入订单ID',
  'views.orderPayment.form.type': '类型',
  'views.orderPayment.form.typePlaceholder': '请选择截图类型',
  'views.orderPayment.form.money': '金额',
  'views.orderPayment.form.moneyPlaceholder': '请输入金额',
  'views.orderPayment.form.url': '付款截图',
  'views.orderPayment.form.urlPlaceholder': '请输入内容',
  'views.orderPayment.form.auditStatus': '审核状态',
  'views.orderPayment.form.auditStatusPlaceholder': '请选择审核状态',
  'views.orderPayment.form.auditReason': '审核原因',
  'views.orderPayment.form.auditReasonPlaceholder': '请输入内容',
  'views.orderPayment.form.auditReasonEn': '审核原因（英文）',
  'views.orderPayment.form.auditReasonEnPlaceholder': '请输入审核原因（英文）',
  'views.orderPayment.form.save': '保存',
  'views.orderPayment.form.cancel': '取消',
  'views.orderPayment.msg.addOk': '新增成功',
  'views.orderPayment.msg.addFail': '新增失败',
  'views.orderPayment.msg.updateOk': '修改成功',
  'views.orderPayment.msg.updateFail': '修改失败',

  'views.goods.search.category': '分类',
  'views.goods.search.categoryPlaceholder': '请选择分类',
  'views.goods.search.name': '名称',
  'views.goods.search.namePlaceholder': '请输入名称',
  'views.goods.search.type': '商品类型',
  'views.goods.search.typePlaceholder': '请选择商品类型',
  'views.goods.type.0': '自立袋',
  'views.goods.type.1': '三边封',
  'views.goods.btn.query': '查询',
  'views.goods.btn.reset': '重置',
  'views.goods.btn.add': '新增',
  'views.goods.btn.edit': '修改',
  'views.goods.btn.delete': '删除',
  'views.goods.column.id': 'ID',
  'views.goods.column.categoryName': '分类',
  'views.goods.column.name': '名称',
  'views.goods.column.type': '商品类型',
  'views.goods.column.imgUrl': '图标',
  'views.goods.column.description': '描述',
  'views.goods.column.content': '产品详情',
  'views.goods.column.sort': '排序',
  'views.goods.column.status': '状态',
  'views.goods.column.createTime': '创建时间',
  'views.goods.column.operation': '操作',
  'views.goods.action.specSameManage': '选择管理',
  'views.goods.drawer.specSameTitle': '选择管理',
  'views.goods.pagination.total': '共 {total} 条',
  'views.goods.confirm.deleteTitle': '确认删除所选中数据?',
  'views.goods.confirm.deleteContent': '当前选中编号为{ids}的数据',
  'views.goods.msg.deleteSuccess': '删除成功',
  'views.goods.confirm.exportTitle': '是否确认导出?',
  'views.goods.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.goods.export.filename': '产品_{time}.xlsx',
  'views.goods.msg.statusOk': '状态更新成功',
  'views.goods.msg.statusFail': '状态更新失败',
  'views.goods.msg.sortOk': '排序更新成功',
  'views.goods.msg.sortFail': '排序更新失败',

  'views.goods.title.add': '添加',
  'views.goods.title.edit': '修改',
  'views.goods.form.category': '分类',
  'views.goods.form.categoryPlaceholder': '请选择分类',
  'views.goods.form.type': '商品类型',
  'views.goods.form.typePlaceholder': '请选择商品类型',
  'views.goods.form.name': '名称',
  'views.goods.form.namePlaceholder': '请输入名称',
  'views.goods.form.nameEn': '名称(英文)',
  'views.goods.form.nameEnPlaceholder': '请输入英文名称',
  'views.goods.form.spec': '规格',
  'views.goods.form.specPlaceholder': '请选择规格（可多选）',
  'views.goods.form.specFallback': '规格({id})',
  'views.goods.form.tagCustom': '定制',
  'views.goods.form.tagPro': '专业用户',
  'views.goods.form.sortLabel': '排序',
  'views.goods.form.selectAll': '全选',
  'views.goods.form.selectNone': '全不选',
  'views.goods.form.combSort': '排序',
  'views.goods.form.combCombo': '组合',
  'views.goods.form.combType': '类型',
  'views.goods.form.combSingle': '单选',
  'views.goods.form.combMulti': '多选',
  'views.goods.form.combDefault': '默认值',
  'views.goods.form.optional': '可不选',
  'views.goods.form.combPickItems': '请选择组合项',
  'views.goods.form.combGroupName': '组合名称',
  'views.goods.form.combNamePlaceholder': '请输入名称',
  'views.goods.form.combGroupNameEn': '组合名称(英文)',
  'views.goods.form.combNameEnPlaceholder': '请输入英文名称',
  'views.goods.form.combDelete': '删除',
  'views.goods.form.combAddRow': '+ 添加组合项',
  'views.goods.form.combTitle': '组合{n}',
  'views.goods.form.specSelected': '已选 {selected} / {total}',
  'views.goods.form.emptyNoOptions': '暂无选项',
  'views.goods.form.emptySelectSpec': '请先选择规格',
  'views.goods.form.dividerSpecOptions': '规格选项',
  'views.goods.form.dividerAssociation': '关联设置',
  'views.goods.form.addAssociation': '新增关联',
  'views.goods.form.associationHint': '暂无关联，可点击“新增关联”添加',
  'views.goods.form.associationCardTitle': '关联{n}',
  'views.goods.form.delete': '删除',
  'views.goods.form.assocSpec': '规格',
  'views.goods.form.assocSpecPlaceholder': '请选择规格',
  'views.goods.form.assocOption': '选项值',
  'views.goods.form.assocOptionPlaceholder': '请选择选项值',
  'views.goods.form.assocTwoSpec': '关联规格',
  'views.goods.form.assocTwoSpecPlaceholder': '请选择关联规格',
  'views.goods.form.assocOptions': '关联选项',
  'views.goods.form.assocOptionsPlaceholder': '请选择关联选项（多选）',
  'views.goods.form.assocDefault': '默认值',
  'views.goods.form.optionFallback': '选项({id})',
  'views.goods.form.compositeMaterials': '其他成本(复合材料)',
  'views.goods.form.compositeMaterialsPlaceholder': '请选择（可多选、可搜索，数据为参与计算的规格选项）',
  'views.goods.form.compositeCost': '复合成本(复合材料)',
  'views.goods.form.compositeCostPlaceholder': '请输入复合成本(复合材料)元/米/层（最多两位小数）',
  'views.goods.form.passRate': '合格率(复合材料)',
  'views.goods.form.passRatePlaceholder': '请输入合格率(复合材料)（最多两位小数）',
  'views.goods.form.toolIds': '刀具费用',
  'views.goods.form.toolIdsPlaceholder': '请选择刀具费用（可多选、可搜索）',
  'views.goods.form.machineTuning': '其他成本(调机成本)',
  'views.goods.form.machineTuningPlaceholder': '请选择（可多选、可搜索，数据为参与计算的规格选项）',
  'views.goods.form.machineCost': '复合成本(调机成本)',
  'views.goods.form.machineCostPlaceholder': '请输入复合成本(调机成本)元/米/层（最多两位小数）',
  'views.goods.form.machineId': '调机米数(调机成本)',
  'views.goods.form.machineIdPlaceholder': '请选择调机米数（可搜索）',
  'views.goods.form.printMultiples': '印刷倍数',
  'views.goods.form.printMultiplesPlaceholder': '请选择印刷倍数（可搜索）',
  'views.goods.form.specialMultipleIds': '特殊倍数',
  'views.goods.form.specialMultipleIdsPlaceholder': '请选择特殊倍数（可多选、可搜索）',
  'views.goods.form.colorAdjustment': '颜色调整费(调机成本)',
  'views.goods.form.colorAdjustmentPlaceholder': '请输入颜色调整费(调机成本)（最多两位小数）',
  'views.goods.form.packagingFee': '耐介质包装费',
  'views.goods.form.packagingFeePlaceholder': '请输入耐介质包装费（最多两位小数）',
  'views.goods.form.sealStripRemaining': '封口条余量(mm)',
  'views.goods.form.sealStripRemainingPlaceholder': '非负整数，单位毫米，默认 0',
  'views.goods.form.installationFee': '单条封口条安装费',
  'views.goods.form.installationFeePlaceholder': '非负金额，保留两位小数，默认 0.00',
  'views.goods.form.url': '图标',
  'views.goods.form.description': '描述',
  'views.goods.form.descriptionPlaceholder': '请输入描述',
  'views.goods.form.descriptionEn': '描述(英文)',
  'views.goods.form.descriptionEnPlaceholder': '请输入英文描述（可选）',
  'views.goods.form.content': '产品详情',
  'views.goods.form.contentEn': '产品详情(英文)',
  'views.goods.form.save': '保存',
  'views.goods.form.cancel': '取消',
  'views.goods.rule.categoryRequired': '请选择分类',
  'views.goods.rule.typeRequired': '请选择商品类型',
  'views.goods.rule.nameRequired': '名称不能为空',
  'views.goods.msg.addOk': '新增成功',
  'views.goods.msg.addFail': '新增失败',
  'views.goods.msg.updateOk': '修改成功',
  'views.goods.msg.updateFail': '修改失败',

  'views.goodsSpecSame.query.specCombinationList': '组合选项（ID 拼接）',
  'views.goodsSpecSame.query.specCombinationListPlaceholder': '请输入组合选项 ID，逗号分隔',
  'views.goodsSpecSame.query.sort': '排序',
  'views.goodsSpecSame.query.sortPlaceholder': '请输入排序',
  'views.goodsSpecSame.btn.query': '查询',
  'views.goodsSpecSame.btn.add': '新增',
  'views.goodsSpecSame.btn.edit': '修改',
  'views.goodsSpecSame.btn.delete': '删除',
  'views.goodsSpecSame.column.id': 'ID',
  'views.goodsSpecSame.column.goodSpecName': '产品规格',
  'views.goodsSpecSame.column.specOptionName': '选中规格选项',
  'views.goodsSpecSame.column.specCombinationNameList': '组合规格选项',
  'views.goodsSpecSame.column.status': '状态',
  'views.goodsSpecSame.column.createTime': '创建时间',
  'views.goodsSpecSame.column.operation': '操作',
  'views.goodsSpecSame.pagination.total': '共 {total} 条',
  'views.goodsSpecSame.confirm.deleteTitle': '确认删除所选中数据?',
  'views.goodsSpecSame.confirm.deleteContent': '当前选中编号为 {ids} 的数据',
  'views.goodsSpecSame.msg.deleteOk': '删除成功',
  'views.goodsSpecSame.confirm.exportTitle': '是否确认导出?',
  'views.goodsSpecSame.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.goodsSpecSame.export.filenamePrefix': '产品规格组合选择',
  'views.goodsSpecSame.msg.statusOk': '状态更新成功',
  'views.goodsSpecSame.msg.statusFail': '状态更新失败',
  'views.goodsSpecSame.msg.sortOk': '排序更新成功',
  'views.goodsSpecSame.msg.sortFail': '排序更新失败',
  'views.goodsSpecSame.title.add': '添加',
  'views.goodsSpecSame.title.edit': '修改',
  'views.goodsSpecSame.form.goodSpec': '产品规格',
  'views.goodsSpecSame.form.goodSpecPlaceholder': '请选择产品规格（可搜索）',
  'views.goodsSpecSame.form.selectedOption': '选中规格选项',
  'views.goodsSpecSame.form.specCombinationPlaceholder': '请选择产品组合（可搜索选项名称）',
  'views.goodsSpecSame.form.specCombinationPlaceholderDisabled': '请先选择产品规格',
  'views.goodsSpecSame.form.combinationOptions': '组合规格选项',
  'views.goodsSpecSame.form.combinationListPlaceholder': '请选择组合选项（可多选）',
  'views.goodsSpecSame.form.combinationListPlaceholderDisabled': '请先选择产品规格',
  'views.goodsSpecSame.form.save': '保存',
  'views.goodsSpecSame.form.cancel': '取消',
  'views.goodsSpecSame.option.goodSpecRow': '{name}（规格行 ID:{id}）',
  'views.goodsSpecSame.option.goodSpecRowId': '规格行 ID:{id}',
  'views.goodsSpecSame.option.comboRow': '{name}（组合 ID:{id}）',
  'views.goodsSpecSame.option.comboRowId': '组合 ID:{id}',
  'views.goodsSpecSame.msg.addOk': '新增成功',
  'views.goodsSpecSame.msg.addFail': '新增失败',
  'views.goodsSpecSame.msg.updateOk': '修改成功',
  'views.goodsSpecSame.msg.updateFail': '修改失败',

  'views.spec.search.name': '名称',
  'views.spec.search.namePlaceholder': '请输入名称',
  'views.spec.search.isCalculation': '是否参与计算',
  'views.spec.search.isCalculationPlaceholder': '请选择是否参与计算',
  'views.spec.search.isConflict': '是否冲突',
  'views.spec.search.isConflictPlaceholder': '请选择是否冲突',
  'views.spec.search.type': '类型',
  'views.spec.search.typePlaceholder': '请选择类型',
  'views.spec.search.isRequired': '是否必填',
  'views.spec.search.isRequiredPlaceholder': '请选择是否必填',
  'views.spec.search.isCustomization': '是否定制',
  'views.spec.search.isCustomizationPlaceholder': '请选择是否定制',
  'views.spec.search.identityRestrictions': '身份类型',
  'views.spec.search.identityRestrictionsPlaceholder': '请选择身份类型',
  'views.spec.search.isPrompt': '是否提示',
  'views.spec.search.isPromptPlaceholder': '请选择是否提示',
  'views.spec.search.isDensity': '是否密度材料',
  'views.spec.search.isDensityPlaceholder': '请选择是否密度材料',
  'views.spec.search.isThickness': '是否正常厚度',
  'views.spec.search.isThicknessPlaceholder': '请选择',
  'views.spec.search.isShow': '是否显示',
  'views.spec.search.isShowPlaceholder': '请选择是否显示',
  'views.spec.btn.query': '查询',
  'views.spec.btn.reset': '重置',
  'views.spec.btn.add': '新增',
  'views.spec.btn.edit': '修改',
  'views.spec.btn.delete': '删除',
  'views.spec.enum.no': '否',
  'views.spec.enum.yes': '是',
  'views.spec.enum.calcNo': '不参与',
  'views.spec.enum.calcYes': '参与',
  'views.spec.enum.requiredNo': '非必填',
  'views.spec.enum.requiredYes': '必填',
  'views.spec.enum.promptNo': '不提示',
  'views.spec.enum.promptYes': '提示',
  'views.spec.enum.identityNormal': '普通用户',
  'views.spec.enum.identityPro': '专业客户',
  'views.spec.enum.typeSingle': '单选',
  'views.spec.enum.typeMulti': '多选',
  'views.spec.column.id': 'ID',
  'views.spec.column.name': '名称',
  'views.spec.column.nameEn': '名称(英文)',
  'views.spec.column.isCalculation': '是否参与计算',
  'views.spec.column.isConflict': '是否冲突',
  'views.spec.column.type': '类型',
  'views.spec.column.isRequired': '是否必填',
  'views.spec.column.isCustomization': '是否定制',
  'views.spec.column.identityRestrictions': '身份类型',
  'views.spec.column.isPrompt': '是否提示',
  'views.spec.column.isDensity': '是否密度材料',
  'views.spec.column.isThickness': '是否正常厚度',
  'views.spec.column.isShow': '是否显示',
  'views.spec.column.sort': '排序',
  'views.spec.column.status': '状态',
  'views.spec.column.createTime': '创建时间',
  'views.spec.column.operation': '操作',
  'views.spec.pagination.total': '共 {total} 条',
  'views.spec.action.optionList': '选项列表',
  'views.spec.confirm.deleteTitle': '确认删除所选中数据?',
  'views.spec.confirm.deleteContent': '当前选中编号为{ids}的数据',
  'views.spec.msg.deleteSuccess': '删除成功',
  'views.spec.confirm.exportTitle': '是否确认导出?',
  'views.spec.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.spec.export.filename': '规格_{time}.xlsx',
  'views.spec.msg.statusOk': '状态更新成功',
  'views.spec.msg.statusFail': '状态更新失败',
  'views.spec.msg.sortOk': '排序更新成功',
  'views.spec.msg.sortFail': '排序更新失败',

  'views.spec.form.isRequired': '是否必填',
  'views.spec.form.isRequiredPlaceholder': '请选择是否必填',
  'views.spec.form.type': '类型',
  'views.spec.form.typePlaceholder': '请选择类型',
  'views.spec.form.name': '名称',
  'views.spec.form.namePlaceholder': '请输入名称',
  'views.spec.form.nameEn': '名称(英文)',
  'views.spec.form.nameEnPlaceholder': '请输入名称(英文)',
  'views.spec.form.isCalculation': '是否参与计算',
  'views.spec.form.isCalculationPlaceholder': '请选择是否参与计算',
  'views.spec.form.isConflict': '是否冲突',
  'views.spec.form.isConflictPlaceholder': '请选择是否冲突',
  'views.spec.form.isCustomization': '是否定制',
  'views.spec.form.isCustomizationPlaceholder': '请选择是否定制',
  'views.spec.form.identityRestrictions': '身份类型',
  'views.spec.form.identityRestrictionsPlaceholder': '请选择身份类型',
  'views.spec.form.isDensity': '是否密度材料',
  'views.spec.form.isDensityPlaceholder': '请选择是否密度材料',
  'views.spec.form.isThickness': '是否正常厚度',
  'views.spec.form.isThicknessPlaceholder': '请选择是否正常厚度',
  'views.spec.form.isShow': '是否显示',
  'views.spec.form.isShowPlaceholder': '请选择是否显示（0-不显示 1-显示）',
  'views.spec.form.dividerOptions': '规格选项',
  'views.spec.form.addOption': '新增选项',
  'views.spec.form.emptyOptions': '暂无选项，可点击「新增选项」添加',
  'views.spec.form.optionTitle': '选项{n}',
  'views.spec.form.removeOption': '删除',
  'views.spec.form.optionName': '名称',
  'views.spec.form.optionNamePlaceholder': '请输入选项名称',
  'views.spec.form.optionNameEn': '名称(英文)',
  'views.spec.form.optionNameEnPlaceholder': '请输入选项名称(英文)',
  'views.spec.form.optionSort': '排序',
  'views.spec.form.optionIsConflict': '是否冲突',
  'views.spec.form.selectPlaceholder': '请选择',
  'views.spec.form.optionRemark': '选项说明',
  'views.spec.form.optionRemarkPlaceholder': '请输入选项说明',
  'views.spec.form.optionRemarkEn': '选项说明(英文)',
  'views.spec.form.optionRemarkEnPlaceholder': '请输入选项说明(英文)，可选',
  'views.spec.form.materialDensity': '材料密度',
  'views.spec.form.membraneWidth': '膜宽',
  'views.spec.form.materialThickness': '材料厚度',
  'views.spec.form.sellingPrice': '销售价',
  'views.spec.form.manuscriptFee': '单支版费',
  'views.spec.form.costPrice': '成本价',
  'views.spec.form.optionLaborCosts': '滑动拉链头和人工费(元/个)',
  'views.spec.form.optionLaborCostsSealStrip': '人工费',
  'views.spec.form.optionLaborWeight': '拉链头的重量(g/个)',
  'views.spec.form.optionWeight': '重量(g)',
  'views.spec.form.optionUnit': '单位',
  'views.spec.form.optionUnitPlaceholder': '请输入单位',
  'views.spec.form.valueLabel': '值',
  'views.spec.form.isPrompt': '是否提示',
  'views.spec.form.isPromptPlaceholder': '请选择是否提示',
  'views.spec.form.imagePrompt': '图片(提示)',
  'views.spec.form.imageUrlPlaceholder': '请输入图片',
  'views.spec.form.contentPrompt': '说明内容(提示)',
  'views.spec.form.contentPromptPlaceholder': '请输入说明内容',
  'views.spec.form.contentEnPrompt': '说明内容(英文)',
  'views.spec.form.contentEnPromptPlaceholder': '请输入说明内容(英文)，可选',
  'views.spec.form.defaultOption': '默认值',
  'views.spec.form.defaultOptionPlaceholder': '请选择默认值（来自子选项）',
  'views.spec.form.save': '保存',
  'views.spec.form.cancel': '取消',
  'views.spec.rule.nameRequired': '名称不能为空',
  'views.spec.rule.optionNameRequired': '请输入选项名称',
  'views.spec.rule.uploadImage': '请上传图片',
  'views.spec.rule.contentRequired': '请输入说明内容',
  'views.spec.title.add': '添加',
  'views.spec.title.edit': '修改',
  'views.spec.msg.addOk': '新增成功',
  'views.spec.msg.addFail': '新增失败',
  'views.spec.msg.updateOk': '修改成功',
  'views.spec.msg.updateFail': '修改失败',

  'views.specOption.drawerTitle': '选项列表',
  'views.specOption.btn.query': '查询',
  'views.specOption.btn.reset': '重置',
  'views.specOption.btn.add': '新增',
  'views.specOption.btn.edit': '修改',
  'views.specOption.btn.view': '查看',
  'views.specOption.btn.delete': '删除',
  'views.specOption.expand': '展开',
  'views.specOption.collapse': '收起',
  'views.specOption.pagination.total': '共 {total} 条',
  'views.specOption.query.specId': '所属规格',
  'views.specOption.query.specIdPlaceholder': '请输入所属规格',
  'views.specOption.query.name': '名称',
  'views.specOption.query.namePlaceholder': '请输入名称',
  'views.specOption.query.parentId': '父选项ID，0为一级',
  'views.specOption.query.parentIdPlaceholder': '请输入父选项ID，0为一级',
  'views.specOption.query.isCalculation': '是否参与计算:0-不参与 1-参与',
  'views.specOption.query.isCalculationPlaceholder': '请输入是否参与计算:0-不参与 1-参与',
  'views.specOption.query.isRequired': '是否必填 0-非必填  1-必填',
  'views.specOption.query.isRequiredPlaceholder': '请输入是否必填 0-非必填  1-必填',
  'views.specOption.query.isConflict': '是否冲突 0-否 1-是',
  'views.specOption.query.isConflictPlaceholder': '请输入是否冲突 0-否 1-是',
  'views.specOption.query.isCustomization': '是否定制:0-否 1-是',
  'views.specOption.query.isCustomizationPlaceholder': '请输入是否定制:0-否 1-是',
  'views.specOption.query.identityRestrictions': '身份类型：0-普通用户 1-专业客户',
  'views.specOption.query.identityRestrictionsPlaceholder': '请输入身份类型：0-普通用户 1-专业客户',
  'views.specOption.query.isPrompt': '是否提示：0-不提示 1-提示',
  'views.specOption.query.isPromptPlaceholder': '请输入是否提示：0-不提示 1-提示',
  'views.specOption.query.defaultOption': '默认选项值',
  'views.specOption.query.defaultOptionPlaceholder': '请输入默认选项值',
  'views.specOption.query.sellingPrice': '销售价',
  'views.specOption.query.sellingPricePlaceholder': '请输入销售价',
  'views.specOption.query.costPrice': '成本价',
  'views.specOption.query.costPricePlaceholder': '请输入成本价',
  'views.specOption.query.materialDensity': '材料密度',
  'views.specOption.query.materialDensityPlaceholder': '请输入材料密度',
  'views.specOption.query.membraneWidth': '膜宽',
  'views.specOption.query.membraneWidthPlaceholder': '请输入膜宽',
  'views.specOption.query.isThickness': '是否正常厚度：0-否 1-是',
  'views.specOption.query.isThicknessPlaceholder': '请输入是否正常厚度：0-否 1-是',
  'views.specOption.query.materialThickness': '材料厚度',
  'views.specOption.query.materialThicknessPlaceholder': '请输入材料厚度',
  'views.specOption.query.url': '图片',
  'views.specOption.query.urlPlaceholder': '请输入图片',
  'views.specOption.query.sort': '排序',
  'views.specOption.query.sortPlaceholder': '请输入排序',
  'views.specOption.column.id': 'ID',
  'views.specOption.column.name': '名称',
  'views.specOption.column.nameEn': '名称(英文)',
  'views.specOption.column.isConflict': '是否冲突',
  'views.specOption.column.remark': '选项说明',
  'views.specOption.column.isPrompt': '是否提示',
  'views.specOption.column.url': '图片(提示)',
  'views.specOption.column.content': '说明内容(提示)',
  'views.specOption.column.sellingPrice': '销售价',
  'views.specOption.column.costPrice': '成本价',
  'views.specOption.column.manuscriptFee': '单支版费',
  'views.specOption.column.materialDensity': '材料密度',
  'views.specOption.column.membraneWidth': '膜宽',
  'views.specOption.column.isThickness': '是否正常厚度',
  'views.specOption.column.materialThickness': '材料厚度',
  'views.specOption.column.sort': '排序',
  'views.specOption.column.status': '状态',
  'views.specOption.column.createTime': '创建时间',
  'views.specOption.column.operation': '操作',
  'views.specOption.format.yes': '是',
  'views.specOption.format.no': '否',
  'views.specOption.format.promptOn': '提示',
  'views.specOption.format.promptOff': '不提示',
  'views.specOption.confirm.deleteTitle': '确认删除所选中数据?',
  'views.specOption.confirm.deleteContent': '当前选中编号为 {ids} 的数据',
  'views.specOption.msg.deleteOk': '删除成功',
  'views.specOption.confirm.exportTitle': '是否确认导出?',
  'views.specOption.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.specOption.export.filenamePrefix': '规格选项树（支持无限层级）',
  'views.specOption.msg.statusOk': '状态更新成功',
  'views.specOption.msg.statusFail': '状态更新失败',
  'views.specOption.msg.sortOk': '排序更新成功',
  'views.specOption.msg.sortFail': '排序更新失败',
  'views.specOption.form.specIdLabel': '所属规格',
  'views.specOption.form.specIdPlaceholder': '请输入所属规格',
  'views.specOption.form.parentId': '父选项ID',
  'views.specOption.form.parentIdPlaceholder': '请输入父选项ID（0为一级）',
  'views.specOption.form.isCalculationInput': '是否参与计算',
  'views.specOption.form.isCalculationInputPlaceholder': '请输入是否参与计算',
  'views.specOption.form.isRequiredInput': '是否必填',
  'views.specOption.form.isRequiredInputPlaceholder': '请输入是否必填',
  'views.specOption.form.type': '类型',
  'views.specOption.form.defaultOptionValuePlaceholder': '请输入默认选项值',

  'views.machine.search.name': '名称',
  'views.machine.search.namePlaceholder': '请输入名称',
  'views.machine.btn.query': '查询',
  'views.machine.btn.reset': '重置',
  'views.machine.btn.add': '新增',
  'views.machine.btn.edit': '修改',
  'views.machine.btn.delete': '删除',
  'views.machine.column.id': 'ID',
  'views.machine.column.name': '名称',
  'views.machine.column.machineMeter': '米数',
  'views.machine.column.doubleMeter': '双放料',
  'views.machine.column.bottomMeter': '添底',
  'views.machine.column.sort': '排序',
  'views.machine.column.status': '状态',
  'views.machine.column.createTime': '创建时间',
  'views.machine.column.operation': '操作',
  'views.machine.pagination.total': '共 {total} 条',
  'views.machine.confirm.deleteTitle': '确认删除所选中数据?',
  'views.machine.confirm.deleteContent': '当前选中编号为{ids}的数据',
  'views.machine.msg.deleteSuccess': '删除成功',
  'views.machine.confirm.exportTitle': '是否确认导出?',
  'views.machine.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.machine.export.filename': '调机米数_{time}.xlsx',
  'views.machine.msg.statusOk': '状态更新成功',
  'views.machine.msg.statusFail': '状态更新失败',
  'views.machine.msg.sortOk': '排序更新成功',
  'views.machine.msg.sortFail': '排序更新失败',
  'views.machine.form.name': '名称',
  'views.machine.form.namePlaceholder': '请输入名称',
  'views.machine.form.machineMeter': '米数',
  'views.machine.form.machineMeterPlaceholder': '请输入米数',
  'views.machine.form.doubleMeter': '双放料',
  'views.machine.form.doubleMeterPlaceholder': '请输入双放料',
  'views.machine.form.bottomMeter': '添底',
  'views.machine.form.bottomMeterPlaceholder': '请输入添底',
  'views.machine.form.save': '保存',
  'views.machine.form.cancel': '取消',
  'views.machine.rule.nameRequired': '名称不能为空',
  'views.machine.title.add': '添加',
  'views.machine.title.edit': '修改',
  'views.machine.msg.addOk': '新增成功',
  'views.machine.msg.addFail': '新增失败',
  'views.machine.msg.updateOk': '修改成功',
  'views.machine.msg.updateFail': '修改失败',

  'views.printMultiples.search.name': '名称',
  'views.printMultiples.search.namePlaceholder': '请输入名称',
  'views.printMultiples.btn.query': '查询',
  'views.printMultiples.btn.reset': '重置',
  'views.printMultiples.btn.add': '新增',
  'views.printMultiples.btn.edit': '修改',
  'views.printMultiples.btn.delete': '删除',
  'views.printMultiples.column.id': 'ID',
  'views.printMultiples.column.name': '名称',
  'views.printMultiples.column.price': '起订价格',
  'views.printMultiples.column.recyclingPrice': '单一可回收起订价',
  'views.printMultiples.column.andDoubleNum': '并二',
  'views.printMultiples.column.andBottomNum': '添底',
  'views.printMultiples.column.andThreeNum': '并三',
  'views.printMultiples.column.andFourNum': '并四',
  'views.printMultiples.column.doubleDischarging': '双放料',
  'views.printMultiples.column.sort': '排序',
  'views.printMultiples.column.status': '状态',
  'views.printMultiples.column.createTime': '创建时间',
  'views.printMultiples.column.operation': '操作',
  'views.printMultiples.pagination.total': '共 {total} 条',
  'views.printMultiples.action.optionLink': '选项关联',
  'views.printMultiples.drawer.optionLinkTitle': '选项关联',
  'views.printMultiples.confirm.deleteTitle': '确认删除所选中数据?',
  'views.printMultiples.confirm.deleteContent': '当前选中编号为{ids}的数据',
  'views.printMultiples.msg.deleteSuccess': '删除成功',
  'views.printMultiples.confirm.exportTitle': '是否确认导出?',
  'views.printMultiples.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.printMultiples.export.filename': '印刷倍数_{time}.xlsx',
  'views.printMultiples.msg.statusOk': '状态更新成功',
  'views.printMultiples.msg.statusFail': '状态更新失败',
  'views.printMultiples.msg.sortOk': '排序更新成功',
  'views.printMultiples.msg.sortFail': '排序更新失败',
  'views.printMultiples.form.name': '名称',
  'views.printMultiples.form.namePlaceholder': '请输入名称',
  'views.printMultiples.form.price': '起订价格',
  'views.printMultiples.form.recyclingPrice': '单一可回收起订价',
  'views.printMultiples.form.andDoubleNum': '并二',
  'views.printMultiples.form.andBottomNum': '添底',
  'views.printMultiples.form.andThreeNum': '并三',
  'views.printMultiples.form.andFourNum': '并四',
  'views.printMultiples.form.doubleDischarging': '双放料',
  'views.printMultiples.form.save': '保存',
  'views.printMultiples.form.cancel': '取消',
  'views.printMultiples.title.add': '添加',
  'views.printMultiples.title.edit': '修改',
  'views.printMultiples.msg.addOk': '新增成功',
  'views.printMultiples.msg.addFail': '新增失败',
  'views.printMultiples.msg.updateOk': '修改成功',
  'views.printMultiples.msg.updateFail': '修改失败',
  'views.printMultiples.action.specialMinimum': '特殊起订价',
  'views.printMultiples.drawer.specialMinimumTitle': '特殊起订价（{name}）',

  'views.specialMinimum.search.printMultiplesId': '印刷倍数ID',
  'views.specialMinimum.search.printMultiplesIdPlaceholder': '请输入印刷倍数ID',
  'views.specialMinimum.search.specOptionId': '规格选项ID',
  'views.specialMinimum.search.specOptionIdPlaceholder': '请输入规格选项ID',
  'views.specialMinimum.search.specOptionSelectPlaceholder': '请选择或搜索规格选项',
  'views.specialMinimum.search.price': '起订价格',
  'views.specialMinimum.search.pricePlaceholder': '请输入起订价格',
  'views.specialMinimum.search.sort': '排序',
  'views.specialMinimum.search.sortPlaceholder': '请输入排序',
  'views.specialMinimum.btn.query': '查询',
  'views.specialMinimum.btn.reset': '重置',
  'views.specialMinimum.btn.expand': '展开',
  'views.specialMinimum.btn.collapse': '收起',
  'views.specialMinimum.btn.add': '新增',
  'views.specialMinimum.btn.edit': '修改',
  'views.specialMinimum.btn.delete': '删除',
  'views.specialMinimum.btn.refresh': '刷新',
  'views.specialMinimum.column.id': 'ID',
  'views.specialMinimum.column.printMultiplesId': '印刷倍数ID',
  'views.specialMinimum.column.specOptionId': '规格选项ID',
  'views.specialMinimum.column.specOptionName': '规格选项',
  'views.specialMinimum.column.price': '起订价格',
  'views.specialMinimum.column.sort': '排序',
  'views.specialMinimum.column.status': '状态',
  'views.specialMinimum.column.createTime': '创建时间',
  'views.specialMinimum.column.operation': '操作',
  'views.specialMinimum.pagination.total': '共 {total} 条',
  'views.specialMinimum.confirm.deleteTitle': '确认删除所选中数据?',
  'views.specialMinimum.confirm.deleteContent': '当前选中编号为{ids}的数据',
  'views.specialMinimum.msg.deleteSuccess': '删除成功',
  'views.specialMinimum.msg.statusOk': '状态更新成功',
  'views.specialMinimum.msg.statusFail': '状态更新失败',
  'views.specialMinimum.msg.sortOk': '排序更新成功',
  'views.specialMinimum.msg.sortFail': '排序更新失败',
  'views.specialMinimum.form.printMultiplesId': '印刷倍数ID',
  'views.specialMinimum.form.printMultiplesIdPlaceholder': '请输入印刷倍数ID',
  'views.specialMinimum.form.specOptionId': '规格选项ID',
  'views.specialMinimum.form.specOptionIdPlaceholder': '请输入规格选项ID',
  'views.specialMinimum.form.specOptionSelectPlaceholder': '请选择或搜索规格选项',
  'views.specialMinimum.form.price': '起订价格',
  'views.specialMinimum.form.pricePlaceholder': '请输入起订价格',
  'views.specialMinimum.form.save': '保存',
  'views.specialMinimum.form.cancel': '取消',
  'views.specialMinimum.title.add': '添加',
  'views.specialMinimum.title.edit': '修改',
  'views.specialMinimum.msg.addOk': '新增成功',
  'views.specialMinimum.msg.addFail': '新增失败',
  'views.specialMinimum.msg.updateOk': '修改成功',
  'views.specialMinimum.msg.updateFail': '修改失败',

  'views.printMultiplesOption.search.multipleNum': '倍数',
  'views.printMultiplesOption.search.multipleNumPlaceholder': '请输入倍数',
  'views.printMultiplesOption.search.sort': '排序',
  'views.printMultiplesOption.search.sortPlaceholder': '请输入排序',
  'views.printMultiplesOption.btn.query': '查询',
  'views.printMultiplesOption.btn.add': '新增',
  'views.printMultiplesOption.btn.edit': '修改',
  'views.printMultiplesOption.btn.delete': '删除',
  'views.printMultiplesOption.column.id': 'ID',
  'views.printMultiplesOption.column.metersNum': '米数',
  'views.printMultiplesOption.column.multipleNum': '倍数',
  'views.printMultiplesOption.column.sort': '排序',
  'views.printMultiplesOption.column.status': '状态',
  'views.printMultiplesOption.column.createTime': '创建时间',
  'views.printMultiplesOption.column.operation': '操作',
  'views.printMultiplesOption.pagination.total': '共 {total} 条',
  'views.printMultiplesOption.confirm.deleteTitle': '确认删除所选中数据?',
  'views.printMultiplesOption.confirm.deleteContent': '当前选中编号为{ids}的数据',
  'views.printMultiplesOption.msg.deleteSuccess': '删除成功',
  'views.printMultiplesOption.confirm.exportTitle': '是否确认导出?',
  'views.printMultiplesOption.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.printMultiplesOption.export.filename': '印刷倍数选项_{time}.xlsx',
  'views.printMultiplesOption.msg.statusOk': '状态更新成功',
  'views.printMultiplesOption.msg.statusFail': '状态更新失败',
  'views.printMultiplesOption.msg.sortOk': '排序更新成功',
  'views.printMultiplesOption.msg.sortFail': '排序更新失败',
  'views.printMultiplesOption.form.metersNum': '米数',
  'views.printMultiplesOption.form.metersNumPlaceholder': '请输入米数（整数）',
  'views.printMultiplesOption.form.multipleNum': '倍数',
  'views.printMultiplesOption.form.multipleNumPlaceholder': '请输入倍数（最多2位小数）',
  'views.printMultiplesOption.form.save': '保存',
  'views.printMultiplesOption.form.cancel': '取消',
  'views.printMultiplesOption.title.add': '添加',
  'views.printMultiplesOption.title.edit': '修改',
  'views.printMultiplesOption.msg.addOk': '新增成功',
  'views.printMultiplesOption.msg.addFail': '新增失败',
  'views.printMultiplesOption.msg.updateOk': '修改成功',
  'views.printMultiplesOption.msg.updateFail': '修改失败',

  'views.cuttingTool.search.name': '名称',
  'views.cuttingTool.search.namePlaceholder': '请输入名称',
  'views.cuttingTool.btn.query': '查询',
  'views.cuttingTool.btn.reset': '重置',
  'views.cuttingTool.btn.add': '新增',
  'views.cuttingTool.btn.edit': '修改',
  'views.cuttingTool.btn.delete': '删除',
  'views.cuttingTool.column.id': 'ID',
  'views.cuttingTool.column.name': '名称',
  'views.cuttingTool.column.bagWidth': '袋宽',
  'views.cuttingTool.column.toolingFee': '刀具费用',
  'views.cuttingTool.column.comparisonSymbols': '比较符',
  'views.cuttingTool.column.sort': '排序',
  'views.cuttingTool.column.status': '状态',
  'views.cuttingTool.column.createTime': '创建时间',
  'views.cuttingTool.column.operation': '操作',
  'views.cuttingTool.pagination.total': '共 {total} 条',
  'views.cuttingTool.confirm.deleteTitle': '确认删除所选中数据?',
  'views.cuttingTool.confirm.deleteContent': '当前选中编号为{ids}的数据',
  'views.cuttingTool.msg.deleteSuccess': '删除成功',
  'views.cuttingTool.confirm.exportTitle': '是否确认导出?',
  'views.cuttingTool.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.cuttingTool.export.filename': '刀具费用_{time}.xlsx',
  'views.cuttingTool.msg.statusOk': '状态更新成功',
  'views.cuttingTool.msg.statusFail': '状态更新失败',
  'views.cuttingTool.msg.sortOk': '排序更新成功',
  'views.cuttingTool.msg.sortFail': '排序更新失败',
  'views.cuttingTool.form.name': '名称',
  'views.cuttingTool.form.namePlaceholder': '请输入名称',
  'views.cuttingTool.form.bagWidth': '袋宽',
  'views.cuttingTool.form.bagWidthPlaceholder': '请输入袋宽',
  'views.cuttingTool.form.toolingFee': '刀具费用',
  'views.cuttingTool.form.toolingFeePlaceholder': '请输入刀具费用',
  'views.cuttingTool.form.comparisonSymbols': '比较符',
  'views.cuttingTool.form.comparisonSymbolsPlaceholder': '请选择比较符',
  'views.cuttingTool.form.save': '保存',
  'views.cuttingTool.form.cancel': '取消',
  'views.cuttingTool.title.add': '添加',
  'views.cuttingTool.title.edit': '修改',
  'views.cuttingTool.msg.addOk': '新增成功',
  'views.cuttingTool.msg.addFail': '新增失败',
  'views.cuttingTool.msg.updateOk': '修改成功',
  'views.cuttingTool.msg.updateFail': '修改失败',

  'views.account.settings.menuBase': '基本设置',
  'views.account.settings.menuSecurity': '安全设置',
  'views.account.settings.titleBase': '基本设置',
  'views.account.settings.titleSecurity': '安全设置',

  'views.account.base.nickName': '昵称',
  'views.account.base.nickNamePlaceholder': '给自己起个名字',
  'views.account.base.phone': '手机',
  'views.account.base.phonePlaceholder': '请填写手机号',
  'views.account.base.email': '电子邮件',
  'views.account.base.emailPlaceholder': '请填写邮箱',
  'views.account.base.sex': '性别',
  'views.account.base.sexMale': '男',
  'views.account.base.sexFemale': '女',
  'views.account.base.save': '保存',
  'views.account.base.rule.nickNameRequired': '请输入昵称',
  'views.account.base.rule.emailRequired': '邮箱不能为空',
  'views.account.base.rule.emailFormat': '请正确填写邮箱地址',
  'views.account.base.rule.phoneRequired': '手机号不能为空',
  'views.account.base.rule.phoneFormat': '请正确填写手机号',
  'views.account.base.notifyTitle': '提示',
  'views.account.base.notifyDescSuccess': '修改成功',

  'views.account.security.passwordTitle': '账户密码',
  'views.account.security.passwordDesc': '当前密码强度',
  'views.account.security.strengthStrong': '强',
  'views.account.security.edit': '修改',

  'views.account.password.title': '重置密码',
  'views.account.password.old': '旧密码',
  'views.account.password.oldPlaceholder': '请输入旧密码',
  'views.account.password.new': '新密码',
  'views.account.password.newPlaceholder': '请输入新密码',
  'views.account.password.confirm': '确认密码',
  'views.account.password.confirmPlaceholder': '请确认密码',
  'views.account.password.rule.oldRequired': '密码不能为空',
  'views.account.password.rule.newRequired': '请输入新密码',
  'views.account.password.rule.newPattern': '请输入5-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种',
  'views.account.password.rule.confirmRequired': '请再次输入新密码确认',
  'views.account.password.rule.confirmMismatch': '两次输入的密码不一致',
  'views.account.password.msgSuccess': '修改成功',

  'views.account.avatar.title': '修改头像',
  'views.account.avatar.selectImage': '选择图片',
  'views.account.avatar.save': '保存',
  'views.account.avatar.uploadSuccess': '上传成功',
  'views.account.avatar.msgSuccess': '上传头像成功',

  'views.account.app.activeUsers': '活跃用户',
  'views.account.app.newUsers': '新增用户',
  'views.account.app.unitTenThousand': '万',

  'views.account.article.tagAntDesign': 'Ant Design',
  'views.account.article.tagDesignLanguage': '设计语言',
  'views.account.article.tagAntFin': '蚂蚁金服',
  'views.account.article.loadMore': '加载更多',
  'views.account.article.demoDescription': '在中台产品的研发过程中，会出现不同的设计规范和实现方式，但其中往往存在很多类似的页面和组件，这些类似的组件会被抽离成一套标准规范。',
  'views.account.article.demoTitle': 'Alipay',
  'views.account.article.demoOwner': '付小小',

  'views.account.center.tabArticle': '文章({n})',
  'views.account.center.tabApp': '应用({n})',
  'views.account.center.tabProject': '项目({n})',
  'views.account.center.demoTag1': '很有想法的',
  'views.account.center.demoTag2': '专注设计',
  'views.account.center.demoTag3': '辣~',
  'views.account.center.demoTag4': '大长腿',
  'views.account.center.demoTag5': '川妹子',
  'views.account.center.demoTag6': '海纳百川',

  'components.avatarDropdown.logout': '退出登录',
  'components.avatarDropdown.logoutConfirmTitle': '提示',
  'components.avatarDropdown.logoutConfirmContent': '确定注销并退出系统吗？',

  'views.bizCancel.search.email': '邮箱',
  'views.bizCancel.search.emailPlaceholder': '请输入邮箱',
  'views.bizCancel.search.status': '审核状态',
  'views.bizCancel.search.statusPlaceholder': '请选择审核状态',
  'views.bizCancel.search.reason': '注销原因',
  'views.bizCancel.search.reasonPlaceholder': '请输入注销原因',
  'views.bizCancel.search.failReason': '审核失败原因',
  'views.bizCancel.search.failReasonPlaceholder': '请输入审核失败原因',
  'views.bizCancel.search.examineName': '审核人',
  'views.bizCancel.search.examineNamePlaceholder': '请输入审核人',
  'views.bizCancel.btn.query': '查询',
  'views.bizCancel.btn.reset': '重置',
  'views.bizCancel.btn.edit': '修改',
  'views.bizCancel.btn.delete': '删除',
  'views.bizCancel.column.email': '注销邮箱',
  'views.bizCancel.column.userEmail': '用户邮箱',
  'views.bizCancel.column.reason': '注销原因',
  'views.bizCancel.column.status': '审核状态',
  'views.bizCancel.column.failReason': '审核失败原因',
  'views.bizCancel.column.examineName': '审核人',
  'views.bizCancel.column.examineTime': '审核时间',
  'views.bizCancel.column.cancelTime': '注销时间',
  'views.bizCancel.column.operation': '操作',
  'views.bizCancel.pagination.total': '共 {total} 条',
  'views.bizCancel.confirm.deleteTitle': '确认删除所选中数据?',
  'views.bizCancel.confirm.deleteContent': '当前选中编号为{ids}的数据',
  'views.bizCancel.msg.deleteSuccess': '删除成功',
  'views.bizCancel.confirm.exportTitle': '是否确认导出?',
  'views.bizCancel.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.bizCancel.export.filename': '用户注销_{time}.xlsx',
  'views.bizCancel.form.email': '注销邮箱',
  'views.bizCancel.form.emailPlaceholder': '注销邮箱',
  'views.bizCancel.form.reason': '注销原因',
  'views.bizCancel.form.reasonPlaceholder': '请输入注销原因',
  'views.bizCancel.form.status': '审核状态',
  'views.bizCancel.form.statusPlaceholder': '请选择审核状态',
  'views.bizCancel.form.failReason': '审核失败原因',
  'views.bizCancel.form.failReasonPlaceholder': '请输入审核失败原因',
  'views.bizCancel.form.save': '保存',
  'views.bizCancel.form.cancel': '取消',
  'views.bizCancel.rule.mobileRequired': '联系电话不能为空',
  'views.bizCancel.rule.mobileFormat': '请正确填写联系电话',
  'views.bizCancel.rule.reasonRequired': '注销原因不能为空',
  'views.bizCancel.rule.statusRequired': '审核状态不能为空',
  'views.bizCancel.title.add': '添加',
  'views.bizCancel.title.audit': '审核',
  'views.bizCancel.msg.updateOk': '修改成功',
  'views.bizCancel.msg.addOk': '新增成功',

  'views.orderSettlement.search.userId': '用户ID',
  'views.orderSettlement.search.userIdPlaceholder': '请输入用户ID',
  'views.orderSettlement.search.orderNo': '结算单号',
  'views.orderSettlement.search.orderNoPlaceholder': '请输入结算单号',
  'views.orderSettlement.search.email': '用户邮箱',
  'views.orderSettlement.search.emailPlaceholder': '请输入用户邮箱',
  'views.orderSettlement.search.nickname': '用户昵称',
  'views.orderSettlement.search.nicknamePlaceholder': '请输入用户昵称',
  'views.orderSettlement.search.orderStatus': '订单状态',
  'views.orderSettlement.search.orderStatusPlaceholder': '请选择订单状态',
  'views.orderSettlement.action.query': '查询',
  'views.orderSettlement.action.reset': '重置',
  'views.orderSettlement.action.generate': '生成',
  'views.orderSettlement.action.paymentRecords': '支付记录',
  'views.orderSettlement.drawer.paymentTitle': '支付记录',
  'views.orderSettlement.action.delete': '删除',
  'views.orderSettlement.column.id': 'ID',
  'views.orderSettlement.column.userId': '用户ID',
  'views.orderSettlement.column.email': '用户邮箱',
  'views.orderSettlement.column.nickname': '用户昵称',
  'views.orderSettlement.column.orderNo': '结算单号',
  'views.orderSettlement.column.orderStatus': '订单状态',
  'views.orderSettlement.column.money': '金额',
  'views.orderSettlement.column.startDate': '开始日期',
  'views.orderSettlement.column.endDate': '结束日期',
  'views.orderSettlement.column.createTime': '创建时间',
  'views.orderSettlement.column.operation': '操作',
  'views.orderSettlement.orderStatus.awaitPay': '待支付',
  'views.orderSettlement.orderStatus.awaitAudit': '待审核',
  'views.orderSettlement.orderStatus.auditRejected': '审核驳回',
  'views.orderSettlement.orderStatus.completed': '已完成',
  'views.orderSettlement.cell.dash': '—',
  'views.orderSettlement.pagination.total': '共 {total} 条',
  'views.orderSettlement.confirm.deleteTitle': '确认删除所选中数据?',
  'views.orderSettlement.confirm.deleteContent': '当前选中编号为 {ids} 的数据',
  'views.orderSettlement.msg.deleteOk': '删除成功',
  'views.orderSettlement.confirm.exportTitle': '是否确认导出?',
  'views.orderSettlement.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.orderSettlement.confirm.generateTitle': '确认生成订单结算？',
  'views.orderSettlement.confirm.generateContent': '将按系统规则处理月结已完成订单并生成本周期结算数据，是否继续？',
  'views.orderSettlement.msg.generateOk': '生成成功',
  'views.orderSettlement.export.filename': '订单结算_{time}.xlsx',

  'views.settlementPayment.column.id': 'ID',
  'views.settlementPayment.column.money': '金额',
  'views.settlementPayment.column.url': '付款截图',
  'views.settlementPayment.column.auditStatus': '审核状态',
  'views.settlementPayment.column.auditReason': '审核原因',
  'views.settlementPayment.column.auditReasonEn': '审核原因(英文)',
  'views.settlementPayment.column.sort': '排序',
  'views.settlementPayment.column.status': '状态',
  'views.settlementPayment.column.createTime': '创建时间',
  'views.settlementPayment.column.operation': '操作',
  'views.settlementPayment.auditStatus.pending': '待审核',
  'views.settlementPayment.auditStatus.approved': '审核通过',
  'views.settlementPayment.auditStatus.rejected': '审核驳回',
  'views.settlementPayment.cell.dash': '—',

  'views.settlementPayment.search.settlementId': '结算ID',
  'views.settlementPayment.search.settlementIdPlaceholder': '请输入结算ID',
  'views.settlementPayment.search.money': '金额',
  'views.settlementPayment.search.moneyPlaceholder': '请输入金额',
  'views.settlementPayment.search.sort': '排序',
  'views.settlementPayment.search.sortPlaceholder': '请输入排序',
  'views.settlementPayment.action.query': '查询',
  'views.settlementPayment.action.reset': '重置',
  'views.settlementPayment.action.expand': '展开',
  'views.settlementPayment.action.collapse': '收起',
  'views.settlementPayment.action.add': '新增',
  'views.settlementPayment.action.edit': '修改',
  'views.settlementPayment.action.audit': '审核',
  'views.settlementPayment.action.delete': '删除',
  'views.settlementPayment.paymentType.full': '全款截图',
  'views.settlementPayment.paymentType.first': '首款截图',
  'views.settlementPayment.paymentType.final': '尾款截图',
  'views.settlementPayment.form.titleAdd': '添加',
  'views.settlementPayment.form.titleEdit': '修改',
  'views.settlementPayment.form.titleAudit': '审核',
  'views.settlementPayment.form.settlementId': '结算ID',
  'views.settlementPayment.form.settlementIdPlaceholder': '请输入结算ID',
  'views.settlementPayment.form.type': '类型',
  'views.settlementPayment.form.typePlaceholder': '请选择截图类型',
  'views.settlementPayment.form.money': '金额',
  'views.settlementPayment.form.moneyPlaceholder': '请输入金额',
  'views.settlementPayment.form.url': '付款截图',
  'views.settlementPayment.form.urlPlaceholder': '请输入截图地址，多个用英文逗号分隔',
  'views.settlementPayment.form.auditStatus': '审核状态',
  'views.settlementPayment.form.auditStatusPlaceholder': '请选择审核状态',
  'views.settlementPayment.form.auditReason': '审核原因',
  'views.settlementPayment.form.auditReasonPlaceholder': '请输入审核原因',
  'views.settlementPayment.form.auditReasonEn': '审核原因（英文）',
  'views.settlementPayment.form.auditReasonEnPlaceholder': '请输入审核原因（英文）',
  'views.settlementPayment.form.save': '保存',
  'views.settlementPayment.form.cancel': '取消',
  'views.settlementPayment.msg.addOk': '新增成功',
  'views.settlementPayment.msg.addFail': '新增失败',
  'views.settlementPayment.msg.updateOk': '修改成功',
  'views.settlementPayment.msg.updateFail': '修改失败',
  'views.settlementPayment.msg.detailFail': '获取详情失败，请稍后重试',
  'views.settlementPayment.pagination.total': '共 {total} 条',
  'views.settlementPayment.confirm.deleteTitle': '确认删除所选中数据?',
  'views.settlementPayment.confirm.deleteContent': '当前选中编号为 {ids} 的数据',
  'views.settlementPayment.confirm.exportTitle': '是否确认导出?',
  'views.settlementPayment.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.settlementPayment.msg.deleteOk': '删除成功',
  'views.settlementPayment.msg.statusUpdateOk': '状态更新成功',
  'views.settlementPayment.msg.statusUpdateFail': '状态更新失败',
  'views.settlementPayment.msg.sortUpdateOk': '排序更新成功',
  'views.settlementPayment.msg.sortUpdateFail': '排序更新失败',
  'views.settlementPayment.export.filename': '结算付款_{time}.xlsx',

  'views.transportation.form.name': '名称',
  'views.transportation.form.namePlaceholder': '请输入名称',
  'views.transportation.form.nameEn': '名称(英文)',
  'views.transportation.form.nameEnPlaceholder': '请输入内容',
  'views.transportation.form.shippingCost': '运输费用(1kg)',
  'views.transportation.form.shippingCostPlaceholder': '请输入运输费用(1kg)',
  'views.transportation.form.save': '保存',
  'views.transportation.form.cancel': '取消',
  'views.transportation.title.add': '添加',
  'views.transportation.title.edit': '修改',
  'views.transportation.msg.addOk': '新增成功',
  'views.transportation.msg.addFail': '新增失败',
  'views.transportation.msg.updateOk': '修改成功',
  'views.transportation.msg.updateFail': '修改失败',

  'views.transportation.query.sort': '排序',
  'views.transportation.query.sortPlaceholder': '请输入排序',
  'views.transportation.btn.query': '查询',
  'views.transportation.btn.reset': '重置',
  'views.transportation.btn.add': '新增',
  'views.transportation.btn.edit': '修改',
  'views.transportation.btn.delete': '删除',
  'views.transportation.column.id': 'ID',
  'views.transportation.column.name': '名称',
  'views.transportation.column.nameEn': '名称(英文)',
  'views.transportation.column.shippingCost': '运输费用(1kg)',
  'views.transportation.column.sort': '排序',
  'views.transportation.column.status': '状态',
  'views.transportation.column.createTime': '创建时间',
  'views.transportation.column.operation': '操作',
  'views.transportation.pagination.total': '共 {total} 条',
  'views.transportation.confirm.deleteTitle': '确认删除所选中数据?',
  'views.transportation.confirm.deleteContent': '当前选中编号为{ids}的数据',
  'views.transportation.confirm.exportTitle': '是否确认导出?',
  'views.transportation.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.transportation.msg.deleteOk': '删除成功',
  'views.transportation.msg.statusUpdateOk': '状态更新成功',
  'views.transportation.msg.statusUpdateFail': '状态更新失败',
  'views.transportation.msg.sortUpdateOk': '排序更新成功',
  'views.transportation.msg.sortUpdateFail': '排序更新失败',
  'views.transportation.export.filename': '运输方式_{time}.xlsx',

  'views.specialMultiple.query.type': '类型',
  'views.specialMultiple.query.typePlaceholder': '请选择类型',
  'views.specialMultiple.query.categoryId': '分类ID',
  'views.specialMultiple.query.categoryIdPlaceholder': '请输入分类ID',
  'views.specialMultiple.query.expression': '尺寸计算公式(front+back，front+back+bottom)',
  'views.specialMultiple.query.expressionPlaceholder': '请输入尺寸计算公式(front+back，front+back+bottom)',
  'views.specialMultiple.query.lowerLimitExclusive': '下限',
  'views.specialMultiple.query.lowerLimitExclusivePlaceholder': '请输入下限',
  'views.specialMultiple.query.upperLimitInclusive': '上限',
  'views.specialMultiple.query.upperLimitInclusivePlaceholder': '请输入上限',
  'views.specialMultiple.query.mode': '计价模式',
  'views.specialMultiple.query.modePlaceholder': '请输入计价模式',
  'views.specialMultiple.query.multiplier': '倍数提升系数',
  'views.specialMultiple.query.multiplierPlaceholder': '请输入倍数提升系数',
  'views.specialMultiple.query.specOptionsList': '选项值',
  'views.specialMultiple.query.specOptionsListPlaceholder': '请选择选项值',
  'views.specialMultiple.query.sort': '排序',
  'views.specialMultiple.query.sortPlaceholder': '请输入排序',
  'views.specialMultiple.type.0': '特殊材料',
  'views.specialMultiple.type.1': '特殊辅料',
  'views.specialMultiple.type.2': '特殊工艺',
  'views.specialMultiple.type.3': '特殊尺寸',
  'views.specialMultiple.btn.query': '查询',
  'views.specialMultiple.btn.reset': '重置',
  'views.specialMultiple.btn.expand': '展开',
  'views.specialMultiple.btn.collapse': '收起',
  'views.specialMultiple.btn.add': '新增',
  'views.specialMultiple.btn.edit': '修改',
  'views.specialMultiple.btn.delete': '删除',
  'views.specialMultiple.column.id': 'ID',
  'views.specialMultiple.column.type': '类型',
  'views.specialMultiple.column.productType': '名称',
  'views.specialMultiple.column.subType': '副标题',
  'views.specialMultiple.column.expression': '尺寸计算公式',
  'views.specialMultiple.column.lowerLimitExclusive': '下限',
  'views.specialMultiple.column.upperLimitInclusive': '上限',
  'views.specialMultiple.column.mode': '并几',
  'views.specialMultiple.column.multiplier': '倍数提升系数',
  'views.specialMultiple.column.specOptionsList': '选项值',
  'views.specialMultiple.column.sort': '排序',
  'views.specialMultiple.column.status': '状态',
  'views.specialMultiple.column.createTime': '创建时间',
  'views.specialMultiple.column.operation': '操作',
  'views.specialMultiple.pagination.total': '共 {total} 条',
  'views.specialMultiple.confirm.deleteTitle': '确认删除所选中数据?',
  'views.specialMultiple.confirm.deleteContent': '当前选中编号为{ids}的数据',
  'views.specialMultiple.confirm.exportTitle': '是否确认导出?',
  'views.specialMultiple.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.specialMultiple.msg.deleteOk': '删除成功',
  'views.specialMultiple.msg.statusUpdateOk': '状态更新成功',
  'views.specialMultiple.msg.statusUpdateFail': '状态更新失败',
  'views.specialMultiple.msg.sortUpdateOk': '排序更新成功',
  'views.specialMultiple.msg.sortUpdateFail': '排序更新失败',
  'views.specialMultiple.export.filename': '特殊倍数_{time}.xlsx',
  'views.specialMultiple.title.add': '添加',
  'views.specialMultiple.title.edit': '修改',
  'views.specialMultiple.form.save': '保存',
  'views.specialMultiple.form.cancel': '取消',
  'views.specialMultiple.form.name': '名称',
  'views.specialMultiple.form.namePlaceholder': '请输入名称',
  'views.specialMultiple.form.productTypePlaceholder': '请输入袋子大类',
  'views.specialMultiple.form.subTypePlaceholder': '请输入副标题',
  'views.specialMultiple.form.expressionBuilder.placeholder': '点击下方按钮组合公式，例如 front+back+bottom',
  'views.specialMultiple.form.expressionToken.front': 'front(正)',
  'views.specialMultiple.form.expressionToken.plus': '+',
  'views.specialMultiple.form.expressionToken.minus': '-',
  'views.specialMultiple.form.expressionToken.multiply': '*',
  'views.specialMultiple.form.expressionToken.divide': '/',
  'views.specialMultiple.form.expressionToken.back': 'back(背)',
  'views.specialMultiple.form.expressionToken.bottom': 'bottom(底)',
  'views.specialMultiple.form.expressionClear': '清空',
  'views.specialMultiple.form.expressionUndo': '撤销',
  'views.specialMultiple.form.expressionFillExample': '填入示例 front+back+bottom',
  'views.specialMultiple.rules.typeRequired': '请选择类型',
  'views.specialMultiple.msg.addOk': '新增成功',
  'views.specialMultiple.msg.addFail': '新增失败',
  'views.specialMultiple.msg.updateOk': '修改成功',
  'views.specialMultiple.msg.updateFail': '修改失败',

  'views.toolMagazine.form.width': '宽度(mm)',
  'views.toolMagazine.form.widthPlaceholder': '请输入宽度(mm)，最多两位小数',
  'views.toolMagazine.form.height': '高度(mm)',
  'views.toolMagazine.form.heightPlaceholder': '请输入高度(mm)，最多两位小数',
  'views.toolMagazine.form.borderDefense': '边封(mm)',
  'views.toolMagazine.form.borderDefensePlaceholder': '请输入边封(mm)，最多两位小数',
  'views.toolMagazine.form.quantity': '数量(个)',
  'views.toolMagazine.form.quantityPlaceholder': '请输入数量(个)，整数',
  'views.toolMagazine.form.specOption': '规格选项',
  'views.toolMagazine.form.specOptionPlaceholder': '请选择或搜索规格选项',
  'views.toolMagazine.query.namePlaceholder': '请输入名称',
  'views.toolMagazine.query.sortPlaceholder': '请输入排序',
  'views.toolMagazine.column.id': 'ID',
  'views.toolMagazine.column.specOptionName': '规格选项',
  'views.toolMagazine.column.name': '名称',
  'views.toolMagazine.column.nameEn': '名称(英文)',
  'views.toolMagazine.column.width': '宽度(mm)',
  'views.toolMagazine.column.height': '高度(mm)',
  'views.toolMagazine.column.borderDefense': '边封(mm)',
  'views.toolMagazine.column.quantity': '数量(个)',
  'views.toolMagazine.column.productionTime': '制作时间',
  'views.toolMagazine.column.sort': '排序',
  'views.toolMagazine.column.status': '状态',
  'views.toolMagazine.column.createTime': '创建时间',
  'views.toolMagazine.column.operation': '操作',
  'views.toolMagazine.btn.query': '查询',
  'views.toolMagazine.btn.reset': '重置',
  'views.toolMagazine.btn.add': '新增',
  'views.toolMagazine.btn.edit': '修改',
  'views.toolMagazine.btn.delete': '删除',
  'views.toolMagazine.btn.import': '导入',
  'views.toolMagazine.import.title': '刀库数据导入',
  'views.toolMagazine.import.uploading': '上传中...',
  'views.toolMagazine.import.dragHint': '将文件拖拽到此处上传',
  'views.toolMagazine.import.clickHint': '支持 .xlsx / .xls，也可点击选择文件',
  'views.toolMagazine.import.downloadTemplate': '下载导入模板',
  'views.toolMagazine.import.fileRequired': '请先选择要导入的文件',
  'views.toolMagazine.import.ok': '导入成功',
  'views.toolMagazine.import.fail': '导入失败',
  'views.toolMagazine.pagination.total': '共 {total} 条',
  'views.toolMagazine.confirm.deleteTitle': '确认删除所选中数据?',
  'views.toolMagazine.confirm.deleteContent': '当前选中编号为{ids}的数据',
  'views.toolMagazine.msg.deleteOk': '删除成功',
  'views.toolMagazine.msg.statusOk': '状态更新成功',
  'views.toolMagazine.msg.statusFail': '状态更新失败',
  'views.toolMagazine.msg.sortOk': '排序更新成功',
  'views.toolMagazine.msg.sortFail': '排序更新失败',

  'views.systemUser.query.userName': '用户名称',
  'views.systemUser.query.userNamePlaceholder': '请输入',
  'views.systemUser.query.phoneNumber': '手机号',
  'views.systemUser.query.phoneNumberPlaceholder': '请输入',
  'views.systemUser.query.status': '状态',
  'views.systemUser.query.statusPlaceholder': '请选择状态',
  'views.systemUser.query.createTime': '创建时间',
  'views.systemUser.btn.query': '查询',
  'views.systemUser.btn.reset': '重置',
  'views.systemUser.btn.add': '新增',
  'views.systemUser.btn.edit': '修改',
  'views.systemUser.btn.delete': '删除',
  'views.systemUser.btn.import': '导入',
  'views.systemUser.btn.more': '更多',
  'views.systemUser.action.resetPassword': '重置密码',
  'views.systemUser.action.assignRole': '分配角色',
  'views.systemUser.column.id': '用户编号',
  'views.systemUser.column.userName': '用户名',
  'views.systemUser.column.phoneNumber': '手机号',
  'views.systemUser.column.nickName': '用户昵称',
  'views.systemUser.column.dept': '部门',
  'views.systemUser.column.status': '状态',
  'views.systemUser.column.createTime': '创建时间',
  'views.systemUser.column.operation': '操作',
  'views.systemUser.pagination.total': '共 {total} 条',
  'views.systemUser.status.enable': '启用',
  'views.systemUser.status.disable': '关闭',
  'views.systemUser.msg.statusSuccess': '{action}成功',
  'views.systemUser.msg.statusFail': '{action}失败, {message}',
  'views.systemUser.msg.statusException': '{action}异常',
  'views.systemUser.confirm.deleteTitle': '确认删除所选中数据?',
  'views.systemUser.confirm.deleteContent': '当前选中编号为{ids}的数据',
  'views.systemUser.msg.deleteSuccess': '删除成功',
  'views.systemUser.confirm.exportTitle': '是否确认导出?',
  'views.systemUser.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.systemUser.deptTree.searchPlaceholder': '请输入搜索内容',
  'views.systemUser.form.nickName': '用户昵称',
  'views.systemUser.form.dept': '部门',
  'views.systemUser.form.phoneNumber': '手机号',
  'views.systemUser.form.email': '邮箱',
  'views.systemUser.form.userName': '用户名',
  'views.systemUser.form.password': '密码',
  'views.systemUser.form.sex': '性别',
  'views.systemUser.form.status': '状态',
  'views.systemUser.form.post': '岗位',
  'views.systemUser.form.role': '角色',
  'views.systemUser.form.remark': '备注',
  'views.systemUser.form.placeholderInput': '请输入',
  'views.systemUser.form.placeholderSelect': '请选择',
  'views.systemUser.form.save': '保存',
  'views.systemUser.form.cancel': '取消',
  'views.systemUser.form.titleAdd': '新增用户',
  'views.systemUser.form.titleEdit': '修改用户',
  'views.systemUser.form.rules.userNameRequired': '用户名不能为空',
  'views.systemUser.form.rules.nickNameRequired': '用户昵称不能为空',
  'views.systemUser.form.rules.deptRequired': '部门不能为空',
  'views.systemUser.form.rules.passwordRequired': '密码不能为空',
  'views.systemUser.form.rules.passwordLength': '用户密码长度必须介于 5 和 20 之间',
  'views.systemUser.form.rules.emailRequired': '邮箱不能为空',
  'views.systemUser.form.rules.emailInvalid': '请正确填写邮箱地址',
  'views.systemUser.form.rules.phoneRequired': '手机号不能为空',
  'views.systemUser.form.rules.phoneInvalid': '请正确填写手机号',
  'views.systemUser.msg.addSuccess': '新增成功',
  'views.systemUser.msg.updateSuccess': '修改成功',
  'views.systemUser.resetPwd.title': '重置密码',
  'views.systemUser.resetPwd.userName': '用户名',
  'views.systemUser.resetPwd.newPassword': '新密码',
  'views.systemUser.resetPwd.newPasswordPlaceholder': '请输入新密码',
  'views.systemUser.resetPwd.confirmPassword': '确认密码',
  'views.systemUser.resetPwd.confirmPasswordPlaceholder': '请确认密码',
  'views.systemUser.resetPwd.err.newPwdRequired': '请输入新密码',
  'views.systemUser.resetPwd.err.newPwdPattern': '请输入5-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种',
  'views.systemUser.resetPwd.err.confirmRequired': '请再次输入新密码确认',
  'views.systemUser.resetPwd.err.confirmMismatch': '两次输入的密码不一致',
  'views.systemUser.resetPwd.msg.success': '重置成功',
  'views.systemUser.authRole.title': '分配角色',
  'views.systemUser.authRole.column.id': '角色编号',
  'views.systemUser.authRole.column.roleName': '角色名称',
  'views.systemUser.authRole.column.roleKey': '权限字符',
  'views.systemUser.authRole.column.createTime': '创建时间',
  'views.systemUser.import.title': '用户导入',
  'views.systemUser.import.uploading': '上传中...',
  'views.systemUser.import.dragHint': '请将文件拖拽到此处上传❥(^_-)',
  'views.systemUser.import.clickHint': '支持单个上传，也可以点击后选择文件上传',
  'views.systemUser.import.updateSupport': '是否更新已经存在的用户数据',
  'views.systemUser.import.downloadTemplate': '下载模板',

  'views.systemRole.query.roleName': '角色名',
  'views.systemRole.query.roleNamePlaceholder': '请输入',
  'views.systemRole.query.roleKey': '权限字符',
  'views.systemRole.query.roleKeyPlaceholder': '请输入',
  'views.systemRole.query.status': '状态',
  'views.systemRole.query.statusPlaceholder': '请选择',
  'views.systemRole.query.createTime': '创建时间',
  'views.systemRole.btn.query': '查询',
  'views.systemRole.btn.reset': '重置',
  'views.systemRole.btn.add': '新增',
  'views.systemRole.btn.edit': '修改',
  'views.systemRole.btn.delete': '删除',
  'views.systemRole.btn.more': '更多',
  'views.systemRole.action.assignUser': '分配用户',
  'views.systemRole.column.id': '角色编号',
  'views.systemRole.column.roleName': '角色名',
  'views.systemRole.column.roleKey': '权限标识',
  'views.systemRole.column.roleSort': '排序',
  'views.systemRole.column.status': '状态',
  'views.systemRole.column.createTime': '创建时间',
  'views.systemRole.column.operation': '操作',
  'views.systemRole.pagination.total': '共 {total} 条',
  'views.systemRole.status.enable': '启用',
  'views.systemRole.status.disable': '关闭',
  'views.systemRole.msg.statusSuccess': '{action}成功',
  'views.systemRole.msg.statusFail': '{action}失败, {message}',
  'views.systemRole.msg.statusException': '{action}异常',
  'views.systemRole.confirm.deleteTitle': '确认删除所选中数据?',
  'views.systemRole.confirm.deleteContent': '当前选中编号为{ids}的数据',
  'views.systemRole.msg.deleteSuccess': '删除成功',
  'views.systemRole.confirm.exportTitle': '是否确认导出?',
  'views.systemRole.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.systemRole.dict.status.0': '禁用',
  'views.systemRole.dict.status.1': '启用',
  'views.systemRole.form.roleName': '角色名称',
  'views.systemRole.form.roleKey': '权限字符',
  'views.systemRole.form.roleKeyTooltip': '控制器中定义的权限字符，如：@PreAuthorize(`@ss.hasRole(\'admin\')`)',
  'views.systemRole.form.roleSort': '排序',
  'views.systemRole.form.status': '状态',
  'views.systemRole.form.menuPermission': '菜单权限',
  'views.systemRole.form.expandCollapse': '展开/折叠',
  'views.systemRole.form.selectAll': '全选/全不选',
  'views.systemRole.form.parentChildLink': '父子联动',
  'views.systemRole.form.parentChildTooltip': '当勾选项为空时方可切换模式，可以点击"全不选"后再次切换。',
  'views.systemRole.form.remark': '备注',
  'views.systemRole.form.placeholderInput': '请输入',
  'views.systemRole.form.save': '保存',
  'views.systemRole.form.cancel': '取消',
  'views.systemRole.form.titleAdd': '添加角色',
  'views.systemRole.form.titleEdit': '修改角色',
  'views.systemRole.form.adminAlert': '超级管理员角色信息 不可更改',
  'views.systemRole.form.rules.roleNameRequired': '角色名称不能为空',
  'views.systemRole.form.rules.roleKeyRequired': '权限字符不能为空',
  'views.systemRole.form.rules.roleSortRequired': '显示顺序不能为空',
  'views.systemRole.msg.addSuccess': '新增成功',
  'views.systemRole.msg.updateSuccess': '修改成功',
  'views.systemRole.msg.updateFail': '修改失败，{message}',

  'views.systemRole.msg.updateFail': '修改失败，{message}',

  'views.systemMenu.query.menuName': '菜单名称',
  'views.systemMenu.query.menuNamePlaceholder': '请输入',
  'views.systemMenu.query.status': '状态',
  'views.systemMenu.query.statusPlaceholder': '请选择',
  'views.systemMenu.btn.query': '查询',
  'views.systemMenu.btn.reset': '重置',
  'views.systemMenu.btn.add': '新增',
  'views.systemMenu.btn.edit': '修改',
  'views.systemMenu.btn.delete': '删除',
  'views.systemMenu.column.menuName': '菜单名称',
  'views.systemMenu.column.icon': '图标',
  'views.systemMenu.column.orderNum': '排序',
  'views.systemMenu.column.perms': '权限标识',
  'views.systemMenu.column.component': '组件路径',
  'views.systemMenu.column.status': '状态',
  'views.systemMenu.column.createTime': '创建时间',
  'views.systemMenu.column.operation': '操作',
  'views.systemMenu.confirm.deleteTitle': '确认删除所选中数据?',
  'views.systemMenu.confirm.deleteContent': '当前选中编号为{ids}的数据',
  'views.systemMenu.msg.deleteSuccess': '删除成功',
  'views.systemMenu.rootDir': '主目录',
  'views.systemMenu.dict.status.0': '禁用',
  'views.systemMenu.dict.status.1': '启用',
  'views.systemMenu.dict.visible.0': '隐藏',
  'views.systemMenu.dict.visible.1': '显示',
  'views.systemMenu.dict.yesNo.0': '否',
  'views.systemMenu.dict.yesNo.1': '是',
  'views.systemMenu.form.parentMenu': '上级菜单',
  'views.systemMenu.form.menuType': '菜单类型',
  'views.systemMenu.form.menuType.dir': '目录',
  'views.systemMenu.form.menuType.menu': '菜单',
  'views.systemMenu.form.menuType.button': '按钮',
  'views.systemMenu.form.icon': '图标',
  'views.systemMenu.form.selectIcon': '选择图标',
  'views.systemMenu.form.collapseIcon': '收起',
  'views.systemMenu.form.menuName': '菜单名称',
  'views.systemMenu.form.orderNum': '排序',
  'views.systemMenu.form.isFrame': '是否外链',
  'views.systemMenu.form.isFrameTooltip': '选择是外链则路由地址需要以`http(s)://`开头',
  'views.systemMenu.form.path': '路由地址',
  'views.systemMenu.form.pathTooltip': '访问的路由地址，如：`user`，如外网地址需内链访问则以`http(s)://`开头',
  'views.systemMenu.form.component': '组件路径',
  'views.systemMenu.form.componentTooltip': '访问的组件路径，如：`system/user/index`，默认在`views`目录下',
  'views.systemMenu.form.perms': '权限标识',
  'views.systemMenu.form.permsTooltip': '控制器中定义的权限字符，如：@PreAuthorize(`@ss.hasPermi(\'system:user:list\')`)',
  'views.systemMenu.form.visible': '是否显示',
  'views.systemMenu.form.visibleTooltip': '选择隐藏则路由将不会出现在侧边栏，但仍然可以访问',
  'views.systemMenu.form.status': '状态',
  'views.systemMenu.form.statusTooltip': '选择停用则路由将不会出现在侧边栏，也不能被访问',
  'views.systemMenu.form.isCache': '是否缓存',
  'views.systemMenu.form.isCacheTooltip': '选择是则会被`keep-alive`缓存，需要匹配组件的`name`和地址保持一致，仅在多页签下有效。',
  'views.systemMenu.form.placeholderInput': '请输入',
  'views.systemMenu.form.placeholderSelect': '请选择',
  'views.systemMenu.form.save': '保存',
  'views.systemMenu.form.cancel': '取消',
  'views.systemMenu.form.titleAdd': '添加菜单',
  'views.systemMenu.form.titleEdit': '修改菜单',
  'views.systemMenu.form.rules.menuNameRequired': '菜单名称不能为空',
  'views.systemMenu.form.rules.orderNumRequired': '菜单顺序不能为空',
  'views.systemMenu.form.rules.pathRequired': '路由地址不能为空',
  'views.systemMenu.form.rules.componentRequired': '组件路径不能为空',
  'views.systemMenu.msg.addSuccess': '新增成功',
  'views.systemMenu.msg.updateSuccess': '修改成功',

  'views.systemDept.query.deptName': '部门名称',
  'views.systemDept.query.deptNamePlaceholder': '请输入',
  'views.systemDept.query.status': '状态',
  'views.systemDept.query.statusPlaceholder': '请选择',
  'views.systemDept.btn.query': '查询',
  'views.systemDept.btn.reset': '重置',
  'views.systemDept.btn.add': '新增',
  'views.systemDept.btn.edit': '修改',
  'views.systemDept.btn.delete': '删除',
  'views.systemDept.column.id': '部门编号',
  'views.systemDept.column.deptName': '部门名称',
  'views.systemDept.column.orderNum': '排序',
  'views.systemDept.column.status': '状态',
  'views.systemDept.column.createTime': '创建时间',
  'views.systemDept.column.operation': '操作',
  'views.systemDept.dict.status.0': '禁用',
  'views.systemDept.dict.status.1': '启用',
  'views.systemDept.status.enable': '启用',
  'views.systemDept.status.disable': '关闭',
  'views.systemDept.msg.statusSuccess': '{action}成功',
  'views.systemDept.msg.statusFail': '{action}失败, {message}',
  'views.systemDept.msg.statusException': '{action}异常',
  'views.systemDept.confirm.deleteTitle': '确认删除所选中数据?',
  'views.systemDept.confirm.deleteContent': '当前选中编号为{ids}的数据',
  'views.systemDept.msg.deleteSuccess': '删除成功',
  'views.systemDept.form.parentDept': '上级部门',
  'views.systemDept.form.deptName': '部门名称',
  'views.systemDept.form.orderNum': '排序',
  'views.systemDept.form.leader': '负责人',
  'views.systemDept.form.phone': '联系电话',
  'views.systemDept.form.email': '邮箱',
  'views.systemDept.form.status': '状态',
  'views.systemDept.form.placeholderInput': '请输入',
  'views.systemDept.form.placeholderSelect': '请选择',
  'views.systemDept.form.save': '保存',
  'views.systemDept.form.cancel': '取消',
  'views.systemDept.form.titleAdd': '添加部门',
  'views.systemDept.form.titleEdit': '修改部门',
  'views.systemDept.form.rules.parentDeptRequired': '上级部门不能为空',
  'views.systemDept.form.rules.deptNameRequired': '部门名称不能为空',
  'views.systemDept.form.rules.orderNumRequired': '排序不能为空',
  'views.systemDept.form.rules.emailInvalid': '请输入正确的邮箱地址',
  'views.systemDept.form.rules.phoneInvalid': '请输入正确的手机号码',
  'views.systemDept.msg.addSuccess': '新增成功',
  'views.systemDept.msg.updateSuccess': '修改成功',

  'views.systemPost.query.postCode': '岗位编码',
  'views.systemPost.query.postCodePlaceholder': '请输入',
  'views.systemPost.query.postName': '岗位名称',
  'views.systemPost.query.postNamePlaceholder': '请输入',
  'views.systemPost.query.status': '状态',
  'views.systemPost.query.statusPlaceholder': '请选择',
  'views.systemPost.btn.query': '查询',
  'views.systemPost.btn.reset': '重置',
  'views.systemPost.btn.add': '新增',
  'views.systemPost.btn.edit': '修改',
  'views.systemPost.btn.delete': '删除',
  'views.systemPost.column.id': '岗位编号',
  'views.systemPost.column.postCode': '岗位编码',
  'views.systemPost.column.postName': '岗位名称',
  'views.systemPost.column.postSort': '顺序',
  'views.systemPost.column.status': '状态',
  'views.systemPost.column.createTime': '创建时间',
  'views.systemPost.column.operation': '操作',
  'views.systemPost.pagination.total': '共 {total} 条',
  'views.systemPost.dict.status.0': '禁用',
  'views.systemPost.dict.status.1': '启用',
  'views.systemPost.status.enable': '启用',
  'views.systemPost.status.disable': '关闭',
  'views.systemPost.msg.statusSuccess': '{action}成功',
  'views.systemPost.msg.statusFail': '{action}失败, {message}',
  'views.systemPost.msg.statusException': '{action}异常',
  'views.systemPost.confirm.deleteTitle': '确认删除所选中数据?',
  'views.systemPost.confirm.deleteContent': '当前选中编号为{ids}的数据',
  'views.systemPost.msg.deleteSuccess': '删除成功',
  'views.systemPost.confirm.exportTitle': '是否确认导出?',
  'views.systemPost.confirm.exportContent': '此操作将导出当前条件下所有数据而非选中数据',
  'views.systemPost.form.postName': '岗位名称',
  'views.systemPost.form.postCode': '岗位编码',
  'views.systemPost.form.postSort': '显示顺序',
  'views.systemPost.form.status': '状态',
  'views.systemPost.form.remark': '备注',
  'views.systemPost.form.placeholderInput': '请输入',
  'views.systemPost.form.save': '保存',
  'views.systemPost.form.cancel': '取消',
  'views.systemPost.form.titleAdd': '添加岗位',
  'views.systemPost.form.titleEdit': '修改岗位',
  'views.systemPost.form.rules.postNameRequired': '岗位名称不能为空',
  'views.systemPost.form.rules.postCodeRequired': '岗位编码不能为空',
  'views.systemPost.form.rules.postSortRequired': '显示顺序不能为空',
  'views.systemPost.msg.addSuccess': '新增成功',
  'views.systemPost.msg.updateSuccess': '修改成功',

  'views.systemUser.dict.sex.0': '保密',
  'views.systemUser.dict.sex.1': '男',
  'views.systemUser.dict.sex.2': '女',
  'views.systemUser.dict.status.0': '停用',
  'views.systemUser.dict.status.1': '正常',

  'views.home.welcomeTitle': '欢迎使用后台管理系统',
  'views.home.welcomeSubtitle': '高效、安全、便捷的管理平台',
  'views.home.systemRunning': '系统运行正常',
  'views.home.versionTag': '版本 {version}',
  'views.home.remindersTitle': '温馨提醒',
  'views.home.systemStatusTitle': '系统状态',
  'views.home.runStatusLabel': '运行状态',
  'views.home.lastUpdate': '最后更新',
  'views.home.supportTitle': '技术支持',
  'views.home.phone': '联系电话',
  'views.home.email': '邮箱地址',
  'views.home.serviceHours': '服务时间',
  'views.home.weekdays': '周一至周五',
  'views.home.serviceTimeRange': '9:30 - 18:00',
  'views.home.versionInfoTitle': '版本信息',
  'views.home.stableVersion': '当前为稳定版本',
  'views.home.footer': '后台管理系统 - 让管理更简单',
  'views.home.reminder.securityTitle': '安全提醒',
  'views.home.reminder.securityContent': '请定期修改密码，确保账户安全。',
  'views.home.reminder.tipTitle': '使用建议',
  'views.home.reminder.tipContent': '建议使用最新版本的 Chrome 浏览器以获得最佳体验。',

  'utils.uploadOss.ossConfigFailed': '获取OSS配置失败',
  'utils.uploadOss.uploadFailedRetry': '上传失败，请重试',
  'utils.uploadOss.uploadFailed': '上传失败：{message}',
  'utils.uploadOss.getConfigFailed': '获取上传配置失败：{message}',
  'utils.uploadOss.unknownError': '未知错误'
}
